/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated/route'
import { Route as AdminRouteImport } from './routes/_admin/route'
import { Route as AuthenticatedIndexImport } from './routes/_authenticated/index'
import { Route as authSignInImport } from './routes/(auth)/sign-in'
import { Route as authOtpImport } from './routes/(auth)/otp'
import { Route as AuthenticatedVouchersRouteImport } from './routes/_authenticated/vouchers/route'
import { Route as AuthenticatedVoucherTypesRouteImport } from './routes/_authenticated/voucher-types/route'
import { Route as AuthenticatedSurveysRouteImport } from './routes/_authenticated/surveys/route'
import { Route as AuthenticatedRatingsRouteImport } from './routes/_authenticated/ratings/route'
import { Route as AuthenticatedProductsRouteImport } from './routes/_authenticated/products/route'
import { Route as AuthenticatedPaymentTransactionsRouteImport } from './routes/_authenticated/payment-transactions/route'
import { Route as AuthenticatedMinigamesRouteImport } from './routes/_authenticated/minigames/route'
import { Route as AuthenticatedInventoriesRouteImport } from './routes/_authenticated/inventories/route'
import { Route as AuthenticatedFormsRouteImport } from './routes/_authenticated/forms/route'
import { Route as AuthenticatedFnsResponsesRouteImport } from './routes/_authenticated/fns-responses/route'
import { Route as AuthenticatedFlashSalesInventoryRouteImport } from './routes/_authenticated/flash-sales-inventory/route'
import { Route as AuthenticatedFlashSalesRouteImport } from './routes/_authenticated/flash-sales/route'
import { Route as AuthenticatedSurveysIndexImport } from './routes/_authenticated/surveys/index'
import { Route as AuthenticatedGameRecordsIndexImport } from './routes/_authenticated/game-records/index'
import { Route as AuthenticatedFormsIndexImport } from './routes/_authenticated/forms/index'
import { Route as AuthenticatedFnsResponsesIndexImport } from './routes/_authenticated/fns-responses/index'
import { Route as AdminAdminIndexImport } from './routes/_admin/admin/index'
import { Route as AuthenticatedSurveysCreateIndexImport } from './routes/_authenticated/surveys/create/index'
import { Route as AuthenticatedSurveysSurveyIdIndexImport } from './routes/_authenticated/surveys/$surveyId/index'
import { Route as AuthenticatedFormsCreateIndexImport } from './routes/_authenticated/forms/create/index'
import { Route as AuthenticatedFormsFormIdIndexImport } from './routes/_authenticated/forms/$formId/index'
import { Route as AdminAdminOrganizationsIndexImport } from './routes/_admin/admin/organizations/index'
import { Route as AdminAdminAgenciesIndexImport } from './routes/_admin/admin/agencies/index'
import { Route as AuthenticatedSurveysSurveyIdEditIndexImport } from './routes/_authenticated/surveys/$surveyId/edit/index'
import { Route as AuthenticatedFormsFormIdEditIndexImport } from './routes/_authenticated/forms/$formId/edit/index'
import { Route as AdminAdminTemplatesCreateIndexImport } from './routes/_admin/admin/templates/create/index'
import { Route as AdminAdminTemplatesTemplateIdIndexImport } from './routes/_admin/admin/templates/$templateId/index'
import { Route as AdminAdminTemplatesTemplateIdVersionIdIndexImport } from './routes/_admin/admin/templates/$templateId/$versionId/index'
import { Route as AdminAdminTemplatesTemplateIdVersionVersionIdIndexImport } from './routes/_admin/admin/templates/$templateId/version/$versionId/index'

// Create Virtual Routes

const AuthenticatedTenantsLazyImport = createFileRoute(
  '/_authenticated/tenants',
)()
const AuthenticatedSyncProductLazyImport = createFileRoute(
  '/_authenticated/sync-product',
)()
const AuthenticatedSlotsLazyImport = createFileRoute('/_authenticated/slots')()
const AuthenticatedShareLinksLazyImport = createFileRoute(
  '/_authenticated/share-links',
)()
const AuthenticatedPointManagementLazyImport = createFileRoute(
  '/_authenticated/point-management',
)()
const AuthenticatedPointExpiryRulesLazyImport = createFileRoute(
  '/_authenticated/point-expiry-rules',
)()
const AuthenticatedPointConfigLazyImport = createFileRoute(
  '/_authenticated/point-config',
)()
const AuthenticatedLoyaltyTiersLazyImport = createFileRoute(
  '/_authenticated/loyalty-tiers',
)()
const AuthenticatedLoyaltyProgramsLazyImport = createFileRoute(
  '/_authenticated/loyalty-programs',
)()
const AuthenticatedBranchesLazyImport = createFileRoute(
  '/_authenticated/branches',
)()
const AuthenticatedBookingsLazyImport = createFileRoute(
  '/_authenticated/bookings',
)()
const AuthenticatedAffiliateTrackingLazyImport = createFileRoute(
  '/_authenticated/affiliate-tracking',
)()
const AuthenticatedAffiliateRequestsLazyImport = createFileRoute(
  '/_authenticated/affiliate-requests',
)()
const AuthenticatedAffiliateConfigLazyImport = createFileRoute(
  '/_authenticated/affiliate-config',
)()
const AuthenticatedAffiliateAnalyticsLazyImport = createFileRoute(
  '/_authenticated/affiliate-analytics',
)()
const errors503LazyImport = createFileRoute('/(errors)/503')()
const errors500LazyImport = createFileRoute('/(errors)/500')()
const errors404LazyImport = createFileRoute('/(errors)/404')()
const errors403LazyImport = createFileRoute('/(errors)/403')()
const errors401LazyImport = createFileRoute('/(errors)/401')()
const authSignUpLazyImport = createFileRoute('/(auth)/sign-up')()
const authSignIn2LazyImport = createFileRoute('/(auth)/sign-in-2')()
const authForgotPasswordLazyImport = createFileRoute(
  '/(auth)/forgot-password',
)()
const AuthenticatedSettingsRouteLazyImport = createFileRoute(
  '/_authenticated/settings',
)()
const AuthenticatedVouchersIndexLazyImport = createFileRoute(
  '/_authenticated/vouchers/',
)()
const AuthenticatedVoucherTypesIndexLazyImport = createFileRoute(
  '/_authenticated/voucher-types/',
)()
const AuthenticatedUserManagementIndexLazyImport = createFileRoute(
  '/_authenticated/user-management/',
)()
const AuthenticatedTasksIndexLazyImport = createFileRoute(
  '/_authenticated/tasks/',
)()
const AuthenticatedSettingsIndexLazyImport = createFileRoute(
  '/_authenticated/settings/',
)()
const AuthenticatedReferralIndexLazyImport = createFileRoute(
  '/_authenticated/referral/',
)()
const AuthenticatedRatingsIndexLazyImport = createFileRoute(
  '/_authenticated/ratings/',
)()
const AuthenticatedProductsIndexLazyImport = createFileRoute(
  '/_authenticated/products/',
)()
const AuthenticatedPaymentTransactionsIndexLazyImport = createFileRoute(
  '/_authenticated/payment-transactions/',
)()
const AuthenticatedOrdersIndexLazyImport = createFileRoute(
  '/_authenticated/orders/',
)()
const AuthenticatedOrderShippingIndexLazyImport = createFileRoute(
  '/_authenticated/order-shipping/',
)()
const AuthenticatedMinigamesIndexLazyImport = createFileRoute(
  '/_authenticated/minigames/',
)()
const AuthenticatedInventoriesIndexLazyImport = createFileRoute(
  '/_authenticated/inventories/',
)()
const AuthenticatedHelpCenterIndexLazyImport = createFileRoute(
  '/_authenticated/help-center/',
)()
const AuthenticatedFlashSalesIndexLazyImport = createFileRoute(
  '/_authenticated/flash-sales/',
)()
const AuthenticatedFlashSalesInventoryIndexLazyImport = createFileRoute(
  '/_authenticated/flash-sales-inventory/',
)()
const AuthenticatedEventsIndexLazyImport = createFileRoute(
  '/_authenticated/events/',
)()
const AuthenticatedEventCategoriesIndexLazyImport = createFileRoute(
  '/_authenticated/event-categories/',
)()
const AuthenticatedContentCategoriesIndexLazyImport = createFileRoute(
  '/_authenticated/content-categories/',
)()
const AuthenticatedColorsIndexLazyImport = createFileRoute(
  '/_authenticated/colors/',
)()
const AuthenticatedChatsIndexLazyImport = createFileRoute(
  '/_authenticated/chats/',
)()
const AuthenticatedCategoriesIndexLazyImport = createFileRoute(
  '/_authenticated/categories/',
)()
const AuthenticatedArticlesIndexLazyImport = createFileRoute(
  '/_authenticated/articles/',
)()
const AuthenticatedAppsIndexLazyImport = createFileRoute(
  '/_authenticated/apps/',
)()
const AuthenticatedZaloZnsLazyImport = createFileRoute(
  '/_authenticated/zalo/zns',
)()
const AuthenticatedZaloOaLazyImport = createFileRoute(
  '/_authenticated/zalo/oa',
)()
const AuthenticatedSettingsShippingLazyImport = createFileRoute(
  '/_authenticated/settings/shipping',
)()
const AuthenticatedSettingsNotificationsLazyImport = createFileRoute(
  '/_authenticated/settings/notifications',
)()
const AuthenticatedSettingsGeneralLazyImport = createFileRoute(
  '/_authenticated/settings/general',
)()
const AuthenticatedSettingsDisplayLazyImport = createFileRoute(
  '/_authenticated/settings/display',
)()
const AuthenticatedSettingsContentLazyImport = createFileRoute(
  '/_authenticated/settings/content',
)()
const AuthenticatedSettingsAppearanceLazyImport = createFileRoute(
  '/_authenticated/settings/appearance',
)()
const AuthenticatedSettingsAccountLazyImport = createFileRoute(
  '/_authenticated/settings/account',
)()
const AuthenticatedReferralRelationshipsLazyImport = createFileRoute(
  '/_authenticated/referral/relationships',
)()
const AuthenticatedReferralConfigLazyImport = createFileRoute(
  '/_authenticated/referral/config',
)()
const AuthenticatedReferralCommissionsLazyImport = createFileRoute(
  '/_authenticated/referral/commissions',
)()
const AuthenticatedReferralCodesLazyImport = createFileRoute(
  '/_authenticated/referral/codes',
)()
const AuthenticatedOrdersOrderIdLazyImport = createFileRoute(
  '/_authenticated/orders/$orderId',
)()
const AuthenticatedMinigamesTemplatesLazyImport = createFileRoute(
  '/_authenticated/minigames/templates',
)()
const AuthenticatedMinigamesCreateLazyImport = createFileRoute(
  '/_authenticated/minigames/create',
)()
const AuthenticatedMessagingViberLazyImport = createFileRoute(
  '/_authenticated/messaging/viber',
)()
const AuthenticatedMessagingSmsLazyImport = createFileRoute(
  '/_authenticated/messaging/sms',
)()
const AuthenticatedMessageManagementZnsLazyImport = createFileRoute(
  '/_authenticated/message-management/zns',
)()
const AuthenticatedMessageManagementViberLazyImport = createFileRoute(
  '/_authenticated/message-management/viber',
)()
const AuthenticatedMessageManagementSmsLazyImport = createFileRoute(
  '/_authenticated/message-management/sms',
)()
const AuthenticatedMessageManagementOaLazyImport = createFileRoute(
  '/_authenticated/message-management/oa',
)()
const AuthenticatedFlashSalesInventoryCampaignIdLazyImport = createFileRoute(
  '/_authenticated/flash-sales-inventory/$campaignId',
)()
const AuthenticatedApiHubCredentialsLazyImport = createFileRoute(
  '/_authenticated/api-hub/credentials',
)()
const AuthenticatedVouchersCreateIndexLazyImport = createFileRoute(
  '/_authenticated/vouchers/create/',
)()
const AuthenticatedVouchersVoucherIdIndexLazyImport = createFileRoute(
  '/_authenticated/vouchers/$voucherId/',
)()
const AuthenticatedVoucherTypesCreateIndexLazyImport = createFileRoute(
  '/_authenticated/voucher-types/create/',
)()
const AuthenticatedVoucherTypesVoucherTypeIdIndexLazyImport = createFileRoute(
  '/_authenticated/voucher-types/$voucherTypeId/',
)()
const AuthenticatedProductsCreateIndexLazyImport = createFileRoute(
  '/_authenticated/products/create/',
)()
const AuthenticatedProductsProductIdIndexLazyImport = createFileRoute(
  '/_authenticated/products/$productId/',
)()
const AuthenticatedPaymentTransactionsTransactionIdIndexLazyImport =
  createFileRoute('/_authenticated/payment-transactions/$transactionId/')()
const AuthenticatedMinigamesCampaignIdIndexLazyImport = createFileRoute(
  '/_authenticated/minigames/$campaignId/',
)()
const AuthenticatedInventoriesInventoryIdIndexLazyImport = createFileRoute(
  '/_authenticated/inventories/$inventoryId/',
)()
const AuthenticatedFnsResponsesResponseIdIndexLazyImport = createFileRoute(
  '/_authenticated/fns-responses/$responseId/',
)()
const AuthenticatedEventsCreateIndexLazyImport = createFileRoute(
  '/_authenticated/events/create/',
)()
const AuthenticatedEventsEventIdIndexLazyImport = createFileRoute(
  '/_authenticated/events/$eventId/',
)()
const AuthenticatedArticlesCreateIndexLazyImport = createFileRoute(
  '/_authenticated/articles/create/',
)()
const AuthenticatedArticlesArticleIdIndexLazyImport = createFileRoute(
  '/_authenticated/articles/$articleId/',
)()
const AdminAdminUsersIndexLazyImport = createFileRoute('/_admin/admin/users/')()
const AdminAdminTenantsIndexLazyImport = createFileRoute(
  '/_admin/admin/tenants/',
)()
const AdminAdminTemplatesIndexLazyImport = createFileRoute(
  '/_admin/admin/templates/',
)()
const AdminAdminSduiIndexLazyImport = createFileRoute('/_admin/admin/sdui/')()
const AdminAdminFeatureManagementIndexLazyImport = createFileRoute(
  '/_admin/admin/feature-management/',
)()
const AdminAdminFeatureFlagsIndexLazyImport = createFileRoute(
  '/_admin/admin/feature-flags/',
)()
const AdminAdminBusinessConfigIndexLazyImport = createFileRoute(
  '/_admin/admin/business-config/',
)()
const AuthenticatedMessagingOttCreateLazyImport = createFileRoute(
  '/_authenticated/messaging/ott/create',
)()
const AuthenticatedVouchersVoucherIdEditIndexLazyImport = createFileRoute(
  '/_authenticated/vouchers/$voucherId/edit/',
)()
const AuthenticatedVoucherTypesVoucherTypeIdEditIndexLazyImport =
  createFileRoute('/_authenticated/voucher-types/$voucherTypeId/edit/')()
const AuthenticatedProductsProductIdEditIndexLazyImport = createFileRoute(
  '/_authenticated/products/$productId/edit/',
)()
const AuthenticatedMinigamesCampaignIdEditIndexLazyImport = createFileRoute(
  '/_authenticated/minigames/$campaignId/edit/',
)()
const AuthenticatedEventsEventIdEditIndexLazyImport = createFileRoute(
  '/_authenticated/events/$eventId/edit/',
)()
const AuthenticatedArticlesArticleIdEditIndexLazyImport = createFileRoute(
  '/_authenticated/articles/$articleId/edit/',
)()
const AdminAdminSduiSduiIdIndexLazyImport = createFileRoute(
  '/_admin/admin/sdui/$sduiId/',
)()
const AdminAdminFeatureFlagsTenantIndexLazyImport = createFileRoute(
  '/_admin/admin/feature-flags/tenant/',
)()
const AdminAdminFeatureFlagsTenantOverridesIndexLazyImport = createFileRoute(
  '/_admin/admin/feature-flags/tenant-overrides/',
)()
const AdminAdminFeatureFlagsCommonIndexLazyImport = createFileRoute(
  '/_admin/admin/feature-flags/common/',
)()
const AdminAdminFeatureFlagsFeatureFlagIdIndexLazyImport = createFileRoute(
  '/_admin/admin/feature-flags/$featureFlagId/',
)()
const AdminAdminBusinessConfigTestIndexLazyImport = createFileRoute(
  '/_admin/admin/business-config/test/',
)()
const AdminAdminBusinessConfigCreateIndexLazyImport = createFileRoute(
  '/_admin/admin/business-config/create/',
)()
const AdminAdminBusinessConfigConfigIdIndexLazyImport = createFileRoute(
  '/_admin/admin/business-config/$configId/',
)()
const AdminAdminApiHubGlobalCredentialsIndexLazyImport = createFileRoute(
  '/_admin/admin/api-hub/global-credentials/',
)()
const AuthenticatedMessageManagementOttCreateCreateLazyImport = createFileRoute(
  '/_authenticated/message-management/ott/create/create',
)()
const AdminAdminBusinessConfigConfigIdEditIndexLazyImport = createFileRoute(
  '/_admin/admin/business-config/$configId/edit/',
)()

// Create/Update Routes

const AuthenticatedRouteRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const AdminRouteRoute = AdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedIndexRoute = AuthenticatedIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedTenantsLazyRoute = AuthenticatedTenantsLazyImport.update({
  id: '/tenants',
  path: '/tenants',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/tenants.lazy').then((d) => d.Route),
)

const AuthenticatedSyncProductLazyRoute =
  AuthenticatedSyncProductLazyImport.update({
    id: '/sync-product',
    path: '/sync-product',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/sync-product.lazy').then((d) => d.Route),
  )

const AuthenticatedSlotsLazyRoute = AuthenticatedSlotsLazyImport.update({
  id: '/slots',
  path: '/slots',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/slots.lazy').then((d) => d.Route),
)

const AuthenticatedShareLinksLazyRoute =
  AuthenticatedShareLinksLazyImport.update({
    id: '/share-links',
    path: '/share-links',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/share-links.lazy').then((d) => d.Route),
  )

const AuthenticatedPointManagementLazyRoute =
  AuthenticatedPointManagementLazyImport.update({
    id: '/point-management',
    path: '/point-management',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/point-management.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedPointExpiryRulesLazyRoute =
  AuthenticatedPointExpiryRulesLazyImport.update({
    id: '/point-expiry-rules',
    path: '/point-expiry-rules',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/point-expiry-rules.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedPointConfigLazyRoute =
  AuthenticatedPointConfigLazyImport.update({
    id: '/point-config',
    path: '/point-config',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/point-config.lazy').then((d) => d.Route),
  )

const AuthenticatedLoyaltyTiersLazyRoute =
  AuthenticatedLoyaltyTiersLazyImport.update({
    id: '/loyalty-tiers',
    path: '/loyalty-tiers',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/loyalty-tiers.lazy').then((d) => d.Route),
  )

const AuthenticatedLoyaltyProgramsLazyRoute =
  AuthenticatedLoyaltyProgramsLazyImport.update({
    id: '/loyalty-programs',
    path: '/loyalty-programs',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/loyalty-programs.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedBranchesLazyRoute = AuthenticatedBranchesLazyImport.update({
  id: '/branches',
  path: '/branches',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/branches.lazy').then((d) => d.Route),
)

const AuthenticatedBookingsLazyRoute = AuthenticatedBookingsLazyImport.update({
  id: '/bookings',
  path: '/bookings',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/bookings.lazy').then((d) => d.Route),
)

const AuthenticatedAffiliateTrackingLazyRoute =
  AuthenticatedAffiliateTrackingLazyImport.update({
    id: '/affiliate-tracking',
    path: '/affiliate-tracking',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/affiliate-tracking.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedAffiliateRequestsLazyRoute =
  AuthenticatedAffiliateRequestsLazyImport.update({
    id: '/affiliate-requests',
    path: '/affiliate-requests',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/affiliate-requests.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedAffiliateConfigLazyRoute =
  AuthenticatedAffiliateConfigLazyImport.update({
    id: '/affiliate-config',
    path: '/affiliate-config',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/affiliate-config.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedAffiliateAnalyticsLazyRoute =
  AuthenticatedAffiliateAnalyticsLazyImport.update({
    id: '/affiliate-analytics',
    path: '/affiliate-analytics',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/affiliate-analytics.lazy').then(
      (d) => d.Route,
    ),
  )

const errors503LazyRoute = errors503LazyImport
  .update({
    id: '/(errors)/503',
    path: '/503',
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() => import('./routes/(errors)/503.lazy').then((d) => d.Route))

const errors500LazyRoute = errors500LazyImport
  .update({
    id: '/(errors)/500',
    path: '/500',
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() => import('./routes/(errors)/500.lazy').then((d) => d.Route))

const errors404LazyRoute = errors404LazyImport
  .update({
    id: '/(errors)/404',
    path: '/404',
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() => import('./routes/(errors)/404.lazy').then((d) => d.Route))

const errors403LazyRoute = errors403LazyImport
  .update({
    id: '/(errors)/403',
    path: '/403',
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() => import('./routes/(errors)/403.lazy').then((d) => d.Route))

const errors401LazyRoute = errors401LazyImport
  .update({
    id: '/(errors)/401',
    path: '/401',
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() => import('./routes/(errors)/401.lazy').then((d) => d.Route))

const authSignUpLazyRoute = authSignUpLazyImport
  .update({
    id: '/(auth)/sign-up',
    path: '/sign-up',
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() => import('./routes/(auth)/sign-up.lazy').then((d) => d.Route))

const authSignIn2LazyRoute = authSignIn2LazyImport
  .update({
    id: '/(auth)/sign-in-2',
    path: '/sign-in-2',
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() => import('./routes/(auth)/sign-in-2.lazy').then((d) => d.Route))

const authForgotPasswordLazyRoute = authForgotPasswordLazyImport
  .update({
    id: '/(auth)/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() =>
    import('./routes/(auth)/forgot-password.lazy').then((d) => d.Route),
  )

const AuthenticatedSettingsRouteLazyRoute =
  AuthenticatedSettingsRouteLazyImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/route.lazy').then((d) => d.Route),
  )

const authSignInRoute = authSignInImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRoute,
} as any)

const authOtpRoute = authOtpImport.update({
  id: '/(auth)/otp',
  path: '/otp',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedVouchersRouteRoute = AuthenticatedVouchersRouteImport.update(
  {
    id: '/vouchers',
    path: '/vouchers',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any,
)

const AuthenticatedVoucherTypesRouteRoute =
  AuthenticatedVoucherTypesRouteImport.update({
    id: '/voucher-types',
    path: '/voucher-types',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedSurveysRouteRoute = AuthenticatedSurveysRouteImport.update({
  id: '/surveys',
  path: '/surveys',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedRatingsRouteRoute = AuthenticatedRatingsRouteImport.update({
  id: '/ratings',
  path: '/ratings',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedProductsRouteRoute = AuthenticatedProductsRouteImport.update(
  {
    id: '/products',
    path: '/products',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any,
)

const AuthenticatedPaymentTransactionsRouteRoute =
  AuthenticatedPaymentTransactionsRouteImport.update({
    id: '/payment-transactions',
    path: '/payment-transactions',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedMinigamesRouteRoute =
  AuthenticatedMinigamesRouteImport.update({
    id: '/minigames',
    path: '/minigames',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedInventoriesRouteRoute =
  AuthenticatedInventoriesRouteImport.update({
    id: '/inventories',
    path: '/inventories',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedFormsRouteRoute = AuthenticatedFormsRouteImport.update({
  id: '/forms',
  path: '/forms',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedFnsResponsesRouteRoute =
  AuthenticatedFnsResponsesRouteImport.update({
    id: '/fns-responses',
    path: '/fns-responses',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedFlashSalesInventoryRouteRoute =
  AuthenticatedFlashSalesInventoryRouteImport.update({
    id: '/flash-sales-inventory',
    path: '/flash-sales-inventory',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedFlashSalesRouteRoute =
  AuthenticatedFlashSalesRouteImport.update({
    id: '/flash-sales',
    path: '/flash-sales',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedVouchersIndexLazyRoute =
  AuthenticatedVouchersIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedVouchersRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/vouchers/index.lazy').then((d) => d.Route),
  )

const AuthenticatedVoucherTypesIndexLazyRoute =
  AuthenticatedVoucherTypesIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedVoucherTypesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/voucher-types/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedUserManagementIndexLazyRoute =
  AuthenticatedUserManagementIndexLazyImport.update({
    id: '/user-management/',
    path: '/user-management/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/user-management/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedTasksIndexLazyRoute =
  AuthenticatedTasksIndexLazyImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/tasks/index.lazy').then((d) => d.Route),
  )

const AuthenticatedSettingsIndexLazyRoute =
  AuthenticatedSettingsIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/index.lazy').then((d) => d.Route),
  )

const AuthenticatedReferralIndexLazyRoute =
  AuthenticatedReferralIndexLazyImport.update({
    id: '/referral/',
    path: '/referral/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/referral/index.lazy').then((d) => d.Route),
  )

const AuthenticatedRatingsIndexLazyRoute =
  AuthenticatedRatingsIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedRatingsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/ratings/index.lazy').then((d) => d.Route),
  )

const AuthenticatedProductsIndexLazyRoute =
  AuthenticatedProductsIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedProductsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/products/index.lazy').then((d) => d.Route),
  )

const AuthenticatedPaymentTransactionsIndexLazyRoute =
  AuthenticatedPaymentTransactionsIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPaymentTransactionsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/payment-transactions/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedOrdersIndexLazyRoute =
  AuthenticatedOrdersIndexLazyImport.update({
    id: '/orders/',
    path: '/orders/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/orders/index.lazy').then((d) => d.Route),
  )

const AuthenticatedOrderShippingIndexLazyRoute =
  AuthenticatedOrderShippingIndexLazyImport.update({
    id: '/order-shipping/',
    path: '/order-shipping/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/order-shipping/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedMinigamesIndexLazyRoute =
  AuthenticatedMinigamesIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedMinigamesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/minigames/index.lazy').then((d) => d.Route),
  )

const AuthenticatedInventoriesIndexLazyRoute =
  AuthenticatedInventoriesIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedInventoriesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/inventories/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedHelpCenterIndexLazyRoute =
  AuthenticatedHelpCenterIndexLazyImport.update({
    id: '/help-center/',
    path: '/help-center/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/help-center/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedFlashSalesIndexLazyRoute =
  AuthenticatedFlashSalesIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedFlashSalesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/flash-sales/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedFlashSalesInventoryIndexLazyRoute =
  AuthenticatedFlashSalesInventoryIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedFlashSalesInventoryRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/flash-sales-inventory/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedEventsIndexLazyRoute =
  AuthenticatedEventsIndexLazyImport.update({
    id: '/events/',
    path: '/events/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/events/index.lazy').then((d) => d.Route),
  )

const AuthenticatedEventCategoriesIndexLazyRoute =
  AuthenticatedEventCategoriesIndexLazyImport.update({
    id: '/event-categories/',
    path: '/event-categories/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/event-categories/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedContentCategoriesIndexLazyRoute =
  AuthenticatedContentCategoriesIndexLazyImport.update({
    id: '/content-categories/',
    path: '/content-categories/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/content-categories/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedColorsIndexLazyRoute =
  AuthenticatedColorsIndexLazyImport.update({
    id: '/colors/',
    path: '/colors/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/colors/index.lazy').then((d) => d.Route),
  )

const AuthenticatedChatsIndexLazyRoute =
  AuthenticatedChatsIndexLazyImport.update({
    id: '/chats/',
    path: '/chats/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/chats/index.lazy').then((d) => d.Route),
  )

const AuthenticatedCategoriesIndexLazyRoute =
  AuthenticatedCategoriesIndexLazyImport.update({
    id: '/categories/',
    path: '/categories/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/categories/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedArticlesIndexLazyRoute =
  AuthenticatedArticlesIndexLazyImport.update({
    id: '/articles/',
    path: '/articles/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/articles/index.lazy').then((d) => d.Route),
  )

const AuthenticatedAppsIndexLazyRoute = AuthenticatedAppsIndexLazyImport.update(
  {
    id: '/apps/',
    path: '/apps/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any,
).lazy(() =>
  import('./routes/_authenticated/apps/index.lazy').then((d) => d.Route),
)

const AuthenticatedSurveysIndexRoute = AuthenticatedSurveysIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedSurveysRouteRoute,
} as any)

const AuthenticatedGameRecordsIndexRoute =
  AuthenticatedGameRecordsIndexImport.update({
    id: '/game-records/',
    path: '/game-records/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedFormsIndexRoute = AuthenticatedFormsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedFormsRouteRoute,
} as any)

const AuthenticatedFnsResponsesIndexRoute =
  AuthenticatedFnsResponsesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedFnsResponsesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/fns-responses/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AdminAdminIndexRoute = AdminAdminIndexImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => AdminRouteRoute,
} as any)

const AuthenticatedZaloZnsLazyRoute = AuthenticatedZaloZnsLazyImport.update({
  id: '/zalo/zns',
  path: '/zalo/zns',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/zalo/zns.lazy').then((d) => d.Route),
)

const AuthenticatedZaloOaLazyRoute = AuthenticatedZaloOaLazyImport.update({
  id: '/zalo/oa',
  path: '/zalo/oa',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/zalo/oa.lazy').then((d) => d.Route),
)

const AuthenticatedSettingsShippingLazyRoute =
  AuthenticatedSettingsShippingLazyImport.update({
    id: '/shipping',
    path: '/shipping',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/shipping.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedSettingsNotificationsLazyRoute =
  AuthenticatedSettingsNotificationsLazyImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/notifications.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedSettingsGeneralLazyRoute =
  AuthenticatedSettingsGeneralLazyImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/general.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedSettingsDisplayLazyRoute =
  AuthenticatedSettingsDisplayLazyImport.update({
    id: '/display',
    path: '/display',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/display.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedSettingsContentLazyRoute =
  AuthenticatedSettingsContentLazyImport.update({
    id: '/content',
    path: '/content',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/content.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedSettingsAppearanceLazyRoute =
  AuthenticatedSettingsAppearanceLazyImport.update({
    id: '/appearance',
    path: '/appearance',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/appearance.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedSettingsAccountLazyRoute =
  AuthenticatedSettingsAccountLazyImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/account.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedReferralRelationshipsLazyRoute =
  AuthenticatedReferralRelationshipsLazyImport.update({
    id: '/referral/relationships',
    path: '/referral/relationships',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/referral/relationships.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedReferralConfigLazyRoute =
  AuthenticatedReferralConfigLazyImport.update({
    id: '/referral/config',
    path: '/referral/config',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/referral/config.lazy').then((d) => d.Route),
  )

const AuthenticatedReferralCommissionsLazyRoute =
  AuthenticatedReferralCommissionsLazyImport.update({
    id: '/referral/commissions',
    path: '/referral/commissions',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/referral/commissions.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedReferralCodesLazyRoute =
  AuthenticatedReferralCodesLazyImport.update({
    id: '/referral/codes',
    path: '/referral/codes',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/referral/codes.lazy').then((d) => d.Route),
  )

const AuthenticatedOrdersOrderIdLazyRoute =
  AuthenticatedOrdersOrderIdLazyImport.update({
    id: '/orders/$orderId',
    path: '/orders/$orderId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/orders/$orderId.lazy').then((d) => d.Route),
  )

const AuthenticatedMinigamesTemplatesLazyRoute =
  AuthenticatedMinigamesTemplatesLazyImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => AuthenticatedMinigamesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/minigames/templates.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedMinigamesCreateLazyRoute =
  AuthenticatedMinigamesCreateLazyImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedMinigamesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/minigames/create.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedMessagingViberLazyRoute =
  AuthenticatedMessagingViberLazyImport.update({
    id: '/messaging/viber',
    path: '/messaging/viber',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/messaging/viber.lazy').then((d) => d.Route),
  )

const AuthenticatedMessagingSmsLazyRoute =
  AuthenticatedMessagingSmsLazyImport.update({
    id: '/messaging/sms',
    path: '/messaging/sms',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/messaging/sms.lazy').then((d) => d.Route),
  )

const AuthenticatedMessageManagementZnsLazyRoute =
  AuthenticatedMessageManagementZnsLazyImport.update({
    id: '/message-management/zns',
    path: '/message-management/zns',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/message-management/zns.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedMessageManagementViberLazyRoute =
  AuthenticatedMessageManagementViberLazyImport.update({
    id: '/message-management/viber',
    path: '/message-management/viber',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/message-management/viber.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedMessageManagementSmsLazyRoute =
  AuthenticatedMessageManagementSmsLazyImport.update({
    id: '/message-management/sms',
    path: '/message-management/sms',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/message-management/sms.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedMessageManagementOaLazyRoute =
  AuthenticatedMessageManagementOaLazyImport.update({
    id: '/message-management/oa',
    path: '/message-management/oa',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/message-management/oa.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedFlashSalesInventoryCampaignIdLazyRoute =
  AuthenticatedFlashSalesInventoryCampaignIdLazyImport.update({
    id: '/$campaignId',
    path: '/$campaignId',
    getParentRoute: () => AuthenticatedFlashSalesInventoryRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/flash-sales-inventory/$campaignId.lazy'
    ).then((d) => d.Route),
  )

const AuthenticatedApiHubCredentialsLazyRoute =
  AuthenticatedApiHubCredentialsLazyImport.update({
    id: '/api-hub/credentials',
    path: '/api-hub/credentials',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/api-hub/credentials.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedVouchersCreateIndexLazyRoute =
  AuthenticatedVouchersCreateIndexLazyImport.update({
    id: '/create/',
    path: '/create/',
    getParentRoute: () => AuthenticatedVouchersRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/vouchers/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedVouchersVoucherIdIndexLazyRoute =
  AuthenticatedVouchersVoucherIdIndexLazyImport.update({
    id: '/$voucherId/',
    path: '/$voucherId/',
    getParentRoute: () => AuthenticatedVouchersRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/vouchers/$voucherId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedVoucherTypesCreateIndexLazyRoute =
  AuthenticatedVoucherTypesCreateIndexLazyImport.update({
    id: '/create/',
    path: '/create/',
    getParentRoute: () => AuthenticatedVoucherTypesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/voucher-types/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedVoucherTypesVoucherTypeIdIndexLazyRoute =
  AuthenticatedVoucherTypesVoucherTypeIdIndexLazyImport.update({
    id: '/$voucherTypeId/',
    path: '/$voucherTypeId/',
    getParentRoute: () => AuthenticatedVoucherTypesRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/voucher-types/$voucherTypeId/index.lazy'
    ).then((d) => d.Route),
  )

const AuthenticatedProductsCreateIndexLazyRoute =
  AuthenticatedProductsCreateIndexLazyImport.update({
    id: '/create/',
    path: '/create/',
    getParentRoute: () => AuthenticatedProductsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/products/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedProductsProductIdIndexLazyRoute =
  AuthenticatedProductsProductIdIndexLazyImport.update({
    id: '/$productId/',
    path: '/$productId/',
    getParentRoute: () => AuthenticatedProductsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/products/$productId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedPaymentTransactionsTransactionIdIndexLazyRoute =
  AuthenticatedPaymentTransactionsTransactionIdIndexLazyImport.update({
    id: '/$transactionId/',
    path: '/$transactionId/',
    getParentRoute: () => AuthenticatedPaymentTransactionsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/payment-transactions/$transactionId/index.lazy'
    ).then((d) => d.Route),
  )

const AuthenticatedMinigamesCampaignIdIndexLazyRoute =
  AuthenticatedMinigamesCampaignIdIndexLazyImport.update({
    id: '/$campaignId/',
    path: '/$campaignId/',
    getParentRoute: () => AuthenticatedMinigamesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/minigames/$campaignId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedInventoriesInventoryIdIndexLazyRoute =
  AuthenticatedInventoriesInventoryIdIndexLazyImport.update({
    id: '/$inventoryId/',
    path: '/$inventoryId/',
    getParentRoute: () => AuthenticatedInventoriesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/inventories/$inventoryId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedFnsResponsesResponseIdIndexLazyRoute =
  AuthenticatedFnsResponsesResponseIdIndexLazyImport.update({
    id: '/$responseId/',
    path: '/$responseId/',
    getParentRoute: () => AuthenticatedFnsResponsesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/fns-responses/$responseId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedEventsCreateIndexLazyRoute =
  AuthenticatedEventsCreateIndexLazyImport.update({
    id: '/events/create/',
    path: '/events/create/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/events/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedEventsEventIdIndexLazyRoute =
  AuthenticatedEventsEventIdIndexLazyImport.update({
    id: '/events/$eventId/',
    path: '/events/$eventId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/events/$eventId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedArticlesCreateIndexLazyRoute =
  AuthenticatedArticlesCreateIndexLazyImport.update({
    id: '/articles/create/',
    path: '/articles/create/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/articles/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedArticlesArticleIdIndexLazyRoute =
  AuthenticatedArticlesArticleIdIndexLazyImport.update({
    id: '/articles/$articleId/',
    path: '/articles/$articleId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/articles/$articleId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AdminAdminUsersIndexLazyRoute = AdminAdminUsersIndexLazyImport.update({
  id: '/admin/users/',
  path: '/admin/users/',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() =>
  import('./routes/_admin/admin/users/index.lazy').then((d) => d.Route),
)

const AdminAdminTenantsIndexLazyRoute = AdminAdminTenantsIndexLazyImport.update(
  {
    id: '/admin/tenants/',
    path: '/admin/tenants/',
    getParentRoute: () => AdminRouteRoute,
  } as any,
).lazy(() =>
  import('./routes/_admin/admin/tenants/index.lazy').then((d) => d.Route),
)

const AdminAdminTemplatesIndexLazyRoute =
  AdminAdminTemplatesIndexLazyImport.update({
    id: '/admin/templates/',
    path: '/admin/templates/',
    getParentRoute: () => AdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_admin/admin/templates/index.lazy').then((d) => d.Route),
  )

const AdminAdminSduiIndexLazyRoute = AdminAdminSduiIndexLazyImport.update({
  id: '/admin/sdui/',
  path: '/admin/sdui/',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() =>
  import('./routes/_admin/admin/sdui/index.lazy').then((d) => d.Route),
)

const AdminAdminFeatureManagementIndexLazyRoute =
  AdminAdminFeatureManagementIndexLazyImport.update({
    id: '/admin/feature-management/',
    path: '/admin/feature-management/',
    getParentRoute: () => AdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_admin/admin/feature-management/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AdminAdminFeatureFlagsIndexLazyRoute =
  AdminAdminFeatureFlagsIndexLazyImport.update({
    id: '/admin/feature-flags/',
    path: '/admin/feature-flags/',
    getParentRoute: () => AdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_admin/admin/feature-flags/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AdminAdminBusinessConfigIndexLazyRoute =
  AdminAdminBusinessConfigIndexLazyImport.update({
    id: '/admin/business-config/',
    path: '/admin/business-config/',
    getParentRoute: () => AdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_admin/admin/business-config/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedSurveysCreateIndexRoute =
  AuthenticatedSurveysCreateIndexImport.update({
    id: '/create/',
    path: '/create/',
    getParentRoute: () => AuthenticatedSurveysRouteRoute,
  } as any)

const AuthenticatedSurveysSurveyIdIndexRoute =
  AuthenticatedSurveysSurveyIdIndexImport.update({
    id: '/$surveyId/',
    path: '/$surveyId/',
    getParentRoute: () => AuthenticatedSurveysRouteRoute,
  } as any)

const AuthenticatedFormsCreateIndexRoute =
  AuthenticatedFormsCreateIndexImport.update({
    id: '/create/',
    path: '/create/',
    getParentRoute: () => AuthenticatedFormsRouteRoute,
  } as any)

const AuthenticatedFormsFormIdIndexRoute =
  AuthenticatedFormsFormIdIndexImport.update({
    id: '/$formId/',
    path: '/$formId/',
    getParentRoute: () => AuthenticatedFormsRouteRoute,
  } as any)

const AdminAdminOrganizationsIndexRoute =
  AdminAdminOrganizationsIndexImport.update({
    id: '/admin/organizations/',
    path: '/admin/organizations/',
    getParentRoute: () => AdminRouteRoute,
  } as any)

const AdminAdminAgenciesIndexRoute = AdminAdminAgenciesIndexImport.update({
  id: '/admin/agencies/',
  path: '/admin/agencies/',
  getParentRoute: () => AdminRouteRoute,
} as any)

const AuthenticatedMessagingOttCreateLazyRoute =
  AuthenticatedMessagingOttCreateLazyImport.update({
    id: '/messaging/ott/create',
    path: '/messaging/ott/create',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/messaging/ott/create.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedVouchersVoucherIdEditIndexLazyRoute =
  AuthenticatedVouchersVoucherIdEditIndexLazyImport.update({
    id: '/$voucherId/edit/',
    path: '/$voucherId/edit/',
    getParentRoute: () => AuthenticatedVouchersRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/vouchers/$voucherId/edit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedVoucherTypesVoucherTypeIdEditIndexLazyRoute =
  AuthenticatedVoucherTypesVoucherTypeIdEditIndexLazyImport.update({
    id: '/$voucherTypeId/edit/',
    path: '/$voucherTypeId/edit/',
    getParentRoute: () => AuthenticatedVoucherTypesRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/voucher-types/$voucherTypeId/edit/index.lazy'
    ).then((d) => d.Route),
  )

const AuthenticatedProductsProductIdEditIndexLazyRoute =
  AuthenticatedProductsProductIdEditIndexLazyImport.update({
    id: '/$productId/edit/',
    path: '/$productId/edit/',
    getParentRoute: () => AuthenticatedProductsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/products/$productId/edit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedMinigamesCampaignIdEditIndexLazyRoute =
  AuthenticatedMinigamesCampaignIdEditIndexLazyImport.update({
    id: '/$campaignId/edit/',
    path: '/$campaignId/edit/',
    getParentRoute: () => AuthenticatedMinigamesRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/minigames/$campaignId/edit/index.lazy'
    ).then((d) => d.Route),
  )

const AuthenticatedEventsEventIdEditIndexLazyRoute =
  AuthenticatedEventsEventIdEditIndexLazyImport.update({
    id: '/events/$eventId/edit/',
    path: '/events/$eventId/edit/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/events/$eventId/edit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedArticlesArticleIdEditIndexLazyRoute =
  AuthenticatedArticlesArticleIdEditIndexLazyImport.update({
    id: '/articles/$articleId/edit/',
    path: '/articles/$articleId/edit/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/articles/$articleId/edit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AdminAdminSduiSduiIdIndexLazyRoute =
  AdminAdminSduiSduiIdIndexLazyImport.update({
    id: '/admin/sdui/$sduiId/',
    path: '/admin/sdui/$sduiId/',
    getParentRoute: () => AdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_admin/admin/sdui/$sduiId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AdminAdminFeatureFlagsTenantIndexLazyRoute =
  AdminAdminFeatureFlagsTenantIndexLazyImport.update({
    id: '/admin/feature-flags/tenant/',
    path: '/admin/feature-flags/tenant/',
    getParentRoute: () => AdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_admin/admin/feature-flags/tenant/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AdminAdminFeatureFlagsTenantOverridesIndexLazyRoute =
  AdminAdminFeatureFlagsTenantOverridesIndexLazyImport.update({
    id: '/admin/feature-flags/tenant-overrides/',
    path: '/admin/feature-flags/tenant-overrides/',
    getParentRoute: () => AdminRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_admin/admin/feature-flags/tenant-overrides/index.lazy'
    ).then((d) => d.Route),
  )

const AdminAdminFeatureFlagsCommonIndexLazyRoute =
  AdminAdminFeatureFlagsCommonIndexLazyImport.update({
    id: '/admin/feature-flags/common/',
    path: '/admin/feature-flags/common/',
    getParentRoute: () => AdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_admin/admin/feature-flags/common/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AdminAdminFeatureFlagsFeatureFlagIdIndexLazyRoute =
  AdminAdminFeatureFlagsFeatureFlagIdIndexLazyImport.update({
    id: '/admin/feature-flags/$featureFlagId/',
    path: '/admin/feature-flags/$featureFlagId/',
    getParentRoute: () => AdminRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_admin/admin/feature-flags/$featureFlagId/index.lazy'
    ).then((d) => d.Route),
  )

const AdminAdminBusinessConfigTestIndexLazyRoute =
  AdminAdminBusinessConfigTestIndexLazyImport.update({
    id: '/admin/business-config/test/',
    path: '/admin/business-config/test/',
    getParentRoute: () => AdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_admin/admin/business-config/test/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AdminAdminBusinessConfigCreateIndexLazyRoute =
  AdminAdminBusinessConfigCreateIndexLazyImport.update({
    id: '/admin/business-config/create/',
    path: '/admin/business-config/create/',
    getParentRoute: () => AdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_admin/admin/business-config/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AdminAdminBusinessConfigConfigIdIndexLazyRoute =
  AdminAdminBusinessConfigConfigIdIndexLazyImport.update({
    id: '/admin/business-config/$configId/',
    path: '/admin/business-config/$configId/',
    getParentRoute: () => AdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_admin/admin/business-config/$configId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AdminAdminApiHubGlobalCredentialsIndexLazyRoute =
  AdminAdminApiHubGlobalCredentialsIndexLazyImport.update({
    id: '/admin/api-hub/global-credentials/',
    path: '/admin/api-hub/global-credentials/',
    getParentRoute: () => AdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_admin/admin/api-hub/global-credentials/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedSurveysSurveyIdEditIndexRoute =
  AuthenticatedSurveysSurveyIdEditIndexImport.update({
    id: '/$surveyId/edit/',
    path: '/$surveyId/edit/',
    getParentRoute: () => AuthenticatedSurveysRouteRoute,
  } as any)

const AuthenticatedFormsFormIdEditIndexRoute =
  AuthenticatedFormsFormIdEditIndexImport.update({
    id: '/$formId/edit/',
    path: '/$formId/edit/',
    getParentRoute: () => AuthenticatedFormsRouteRoute,
  } as any)

const AdminAdminTemplatesCreateIndexRoute =
  AdminAdminTemplatesCreateIndexImport.update({
    id: '/admin/templates/create/',
    path: '/admin/templates/create/',
    getParentRoute: () => AdminRouteRoute,
  } as any)

const AdminAdminTemplatesTemplateIdIndexRoute =
  AdminAdminTemplatesTemplateIdIndexImport.update({
    id: '/admin/templates/$templateId/',
    path: '/admin/templates/$templateId/',
    getParentRoute: () => AdminRouteRoute,
  } as any)

const AuthenticatedMessageManagementOttCreateCreateLazyRoute =
  AuthenticatedMessageManagementOttCreateCreateLazyImport.update({
    id: '/message-management/ott/create/create',
    path: '/message-management/ott/create/create',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/message-management/ott/create/create.lazy'
    ).then((d) => d.Route),
  )

const AdminAdminBusinessConfigConfigIdEditIndexLazyRoute =
  AdminAdminBusinessConfigConfigIdEditIndexLazyImport.update({
    id: '/admin/business-config/$configId/edit/',
    path: '/admin/business-config/$configId/edit/',
    getParentRoute: () => AdminRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_admin/admin/business-config/$configId/edit/index.lazy'
    ).then((d) => d.Route),
  )

const AdminAdminTemplatesTemplateIdVersionIdIndexRoute =
  AdminAdminTemplatesTemplateIdVersionIdIndexImport.update({
    id: '/admin/templates/$templateId/$versionId/',
    path: '/admin/templates/$templateId/$versionId/',
    getParentRoute: () => AdminRouteRoute,
  } as any)

const AdminAdminTemplatesTemplateIdVersionVersionIdIndexRoute =
  AdminAdminTemplatesTemplateIdVersionVersionIdIndexImport.update({
    id: '/admin/templates/$templateId/version/$versionId/',
    path: '/admin/templates/$templateId/version/$versionId/',
    getParentRoute: () => AdminRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_admin': {
      id: '/_admin'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/flash-sales': {
      id: '/_authenticated/flash-sales'
      path: '/flash-sales'
      fullPath: '/flash-sales'
      preLoaderRoute: typeof AuthenticatedFlashSalesRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/flash-sales-inventory': {
      id: '/_authenticated/flash-sales-inventory'
      path: '/flash-sales-inventory'
      fullPath: '/flash-sales-inventory'
      preLoaderRoute: typeof AuthenticatedFlashSalesInventoryRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/fns-responses': {
      id: '/_authenticated/fns-responses'
      path: '/fns-responses'
      fullPath: '/fns-responses'
      preLoaderRoute: typeof AuthenticatedFnsResponsesRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/forms': {
      id: '/_authenticated/forms'
      path: '/forms'
      fullPath: '/forms'
      preLoaderRoute: typeof AuthenticatedFormsRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/inventories': {
      id: '/_authenticated/inventories'
      path: '/inventories'
      fullPath: '/inventories'
      preLoaderRoute: typeof AuthenticatedInventoriesRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/minigames': {
      id: '/_authenticated/minigames'
      path: '/minigames'
      fullPath: '/minigames'
      preLoaderRoute: typeof AuthenticatedMinigamesRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/payment-transactions': {
      id: '/_authenticated/payment-transactions'
      path: '/payment-transactions'
      fullPath: '/payment-transactions'
      preLoaderRoute: typeof AuthenticatedPaymentTransactionsRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/products': {
      id: '/_authenticated/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof AuthenticatedProductsRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/ratings': {
      id: '/_authenticated/ratings'
      path: '/ratings'
      fullPath: '/ratings'
      preLoaderRoute: typeof AuthenticatedRatingsRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/surveys': {
      id: '/_authenticated/surveys'
      path: '/surveys'
      fullPath: '/surveys'
      preLoaderRoute: typeof AuthenticatedSurveysRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/voucher-types': {
      id: '/_authenticated/voucher-types'
      path: '/voucher-types'
      fullPath: '/voucher-types'
      preLoaderRoute: typeof AuthenticatedVoucherTypesRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/vouchers': {
      id: '/_authenticated/vouchers'
      path: '/vouchers'
      fullPath: '/vouchers'
      preLoaderRoute: typeof AuthenticatedVouchersRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/(auth)/otp': {
      id: '/(auth)/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof authOtpImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordLazyImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/sign-in-2': {
      id: '/(auth)/sign-in-2'
      path: '/sign-in-2'
      fullPath: '/sign-in-2'
      preLoaderRoute: typeof authSignIn2LazyImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/sign-up': {
      id: '/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpLazyImport
      parentRoute: typeof rootRoute
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401LazyImport
      parentRoute: typeof rootRoute
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403LazyImport
      parentRoute: typeof rootRoute
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404LazyImport
      parentRoute: typeof rootRoute
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500LazyImport
      parentRoute: typeof rootRoute
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503LazyImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/affiliate-analytics': {
      id: '/_authenticated/affiliate-analytics'
      path: '/affiliate-analytics'
      fullPath: '/affiliate-analytics'
      preLoaderRoute: typeof AuthenticatedAffiliateAnalyticsLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/affiliate-config': {
      id: '/_authenticated/affiliate-config'
      path: '/affiliate-config'
      fullPath: '/affiliate-config'
      preLoaderRoute: typeof AuthenticatedAffiliateConfigLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/affiliate-requests': {
      id: '/_authenticated/affiliate-requests'
      path: '/affiliate-requests'
      fullPath: '/affiliate-requests'
      preLoaderRoute: typeof AuthenticatedAffiliateRequestsLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/affiliate-tracking': {
      id: '/_authenticated/affiliate-tracking'
      path: '/affiliate-tracking'
      fullPath: '/affiliate-tracking'
      preLoaderRoute: typeof AuthenticatedAffiliateTrackingLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/bookings': {
      id: '/_authenticated/bookings'
      path: '/bookings'
      fullPath: '/bookings'
      preLoaderRoute: typeof AuthenticatedBookingsLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/branches': {
      id: '/_authenticated/branches'
      path: '/branches'
      fullPath: '/branches'
      preLoaderRoute: typeof AuthenticatedBranchesLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/loyalty-programs': {
      id: '/_authenticated/loyalty-programs'
      path: '/loyalty-programs'
      fullPath: '/loyalty-programs'
      preLoaderRoute: typeof AuthenticatedLoyaltyProgramsLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/loyalty-tiers': {
      id: '/_authenticated/loyalty-tiers'
      path: '/loyalty-tiers'
      fullPath: '/loyalty-tiers'
      preLoaderRoute: typeof AuthenticatedLoyaltyTiersLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/point-config': {
      id: '/_authenticated/point-config'
      path: '/point-config'
      fullPath: '/point-config'
      preLoaderRoute: typeof AuthenticatedPointConfigLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/point-expiry-rules': {
      id: '/_authenticated/point-expiry-rules'
      path: '/point-expiry-rules'
      fullPath: '/point-expiry-rules'
      preLoaderRoute: typeof AuthenticatedPointExpiryRulesLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/point-management': {
      id: '/_authenticated/point-management'
      path: '/point-management'
      fullPath: '/point-management'
      preLoaderRoute: typeof AuthenticatedPointManagementLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/share-links': {
      id: '/_authenticated/share-links'
      path: '/share-links'
      fullPath: '/share-links'
      preLoaderRoute: typeof AuthenticatedShareLinksLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/slots': {
      id: '/_authenticated/slots'
      path: '/slots'
      fullPath: '/slots'
      preLoaderRoute: typeof AuthenticatedSlotsLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/sync-product': {
      id: '/_authenticated/sync-product'
      path: '/sync-product'
      fullPath: '/sync-product'
      preLoaderRoute: typeof AuthenticatedSyncProductLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/tenants': {
      id: '/_authenticated/tenants'
      path: '/tenants'
      fullPath: '/tenants'
      preLoaderRoute: typeof AuthenticatedTenantsLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/api-hub/credentials': {
      id: '/_authenticated/api-hub/credentials'
      path: '/api-hub/credentials'
      fullPath: '/api-hub/credentials'
      preLoaderRoute: typeof AuthenticatedApiHubCredentialsLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/flash-sales-inventory/$campaignId': {
      id: '/_authenticated/flash-sales-inventory/$campaignId'
      path: '/$campaignId'
      fullPath: '/flash-sales-inventory/$campaignId'
      preLoaderRoute: typeof AuthenticatedFlashSalesInventoryCampaignIdLazyImport
      parentRoute: typeof AuthenticatedFlashSalesInventoryRouteImport
    }
    '/_authenticated/message-management/oa': {
      id: '/_authenticated/message-management/oa'
      path: '/message-management/oa'
      fullPath: '/message-management/oa'
      preLoaderRoute: typeof AuthenticatedMessageManagementOaLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/message-management/sms': {
      id: '/_authenticated/message-management/sms'
      path: '/message-management/sms'
      fullPath: '/message-management/sms'
      preLoaderRoute: typeof AuthenticatedMessageManagementSmsLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/message-management/viber': {
      id: '/_authenticated/message-management/viber'
      path: '/message-management/viber'
      fullPath: '/message-management/viber'
      preLoaderRoute: typeof AuthenticatedMessageManagementViberLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/message-management/zns': {
      id: '/_authenticated/message-management/zns'
      path: '/message-management/zns'
      fullPath: '/message-management/zns'
      preLoaderRoute: typeof AuthenticatedMessageManagementZnsLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/messaging/sms': {
      id: '/_authenticated/messaging/sms'
      path: '/messaging/sms'
      fullPath: '/messaging/sms'
      preLoaderRoute: typeof AuthenticatedMessagingSmsLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/messaging/viber': {
      id: '/_authenticated/messaging/viber'
      path: '/messaging/viber'
      fullPath: '/messaging/viber'
      preLoaderRoute: typeof AuthenticatedMessagingViberLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/minigames/create': {
      id: '/_authenticated/minigames/create'
      path: '/create'
      fullPath: '/minigames/create'
      preLoaderRoute: typeof AuthenticatedMinigamesCreateLazyImport
      parentRoute: typeof AuthenticatedMinigamesRouteImport
    }
    '/_authenticated/minigames/templates': {
      id: '/_authenticated/minigames/templates'
      path: '/templates'
      fullPath: '/minigames/templates'
      preLoaderRoute: typeof AuthenticatedMinigamesTemplatesLazyImport
      parentRoute: typeof AuthenticatedMinigamesRouteImport
    }
    '/_authenticated/orders/$orderId': {
      id: '/_authenticated/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof AuthenticatedOrdersOrderIdLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/referral/codes': {
      id: '/_authenticated/referral/codes'
      path: '/referral/codes'
      fullPath: '/referral/codes'
      preLoaderRoute: typeof AuthenticatedReferralCodesLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/referral/commissions': {
      id: '/_authenticated/referral/commissions'
      path: '/referral/commissions'
      fullPath: '/referral/commissions'
      preLoaderRoute: typeof AuthenticatedReferralCommissionsLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/referral/config': {
      id: '/_authenticated/referral/config'
      path: '/referral/config'
      fullPath: '/referral/config'
      preLoaderRoute: typeof AuthenticatedReferralConfigLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/referral/relationships': {
      id: '/_authenticated/referral/relationships'
      path: '/referral/relationships'
      fullPath: '/referral/relationships'
      preLoaderRoute: typeof AuthenticatedReferralRelationshipsLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/settings/account': {
      id: '/_authenticated/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedSettingsAccountLazyImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyImport
    }
    '/_authenticated/settings/appearance': {
      id: '/_authenticated/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof AuthenticatedSettingsAppearanceLazyImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyImport
    }
    '/_authenticated/settings/content': {
      id: '/_authenticated/settings/content'
      path: '/content'
      fullPath: '/settings/content'
      preLoaderRoute: typeof AuthenticatedSettingsContentLazyImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyImport
    }
    '/_authenticated/settings/display': {
      id: '/_authenticated/settings/display'
      path: '/display'
      fullPath: '/settings/display'
      preLoaderRoute: typeof AuthenticatedSettingsDisplayLazyImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyImport
    }
    '/_authenticated/settings/general': {
      id: '/_authenticated/settings/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof AuthenticatedSettingsGeneralLazyImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyImport
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsLazyImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyImport
    }
    '/_authenticated/settings/shipping': {
      id: '/_authenticated/settings/shipping'
      path: '/shipping'
      fullPath: '/settings/shipping'
      preLoaderRoute: typeof AuthenticatedSettingsShippingLazyImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyImport
    }
    '/_authenticated/zalo/oa': {
      id: '/_authenticated/zalo/oa'
      path: '/zalo/oa'
      fullPath: '/zalo/oa'
      preLoaderRoute: typeof AuthenticatedZaloOaLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/zalo/zns': {
      id: '/_authenticated/zalo/zns'
      path: '/zalo/zns'
      fullPath: '/zalo/zns'
      preLoaderRoute: typeof AuthenticatedZaloZnsLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_admin/admin/': {
      id: '/_admin/admin/'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminAdminIndexImport
      parentRoute: typeof AdminRouteImport
    }
    '/_authenticated/fns-responses/': {
      id: '/_authenticated/fns-responses/'
      path: '/'
      fullPath: '/fns-responses/'
      preLoaderRoute: typeof AuthenticatedFnsResponsesIndexImport
      parentRoute: typeof AuthenticatedFnsResponsesRouteImport
    }
    '/_authenticated/forms/': {
      id: '/_authenticated/forms/'
      path: '/'
      fullPath: '/forms/'
      preLoaderRoute: typeof AuthenticatedFormsIndexImport
      parentRoute: typeof AuthenticatedFormsRouteImport
    }
    '/_authenticated/game-records/': {
      id: '/_authenticated/game-records/'
      path: '/game-records'
      fullPath: '/game-records'
      preLoaderRoute: typeof AuthenticatedGameRecordsIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/surveys/': {
      id: '/_authenticated/surveys/'
      path: '/'
      fullPath: '/surveys/'
      preLoaderRoute: typeof AuthenticatedSurveysIndexImport
      parentRoute: typeof AuthenticatedSurveysRouteImport
    }
    '/_authenticated/apps/': {
      id: '/_authenticated/apps/'
      path: '/apps'
      fullPath: '/apps'
      preLoaderRoute: typeof AuthenticatedAppsIndexLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/articles/': {
      id: '/_authenticated/articles/'
      path: '/articles'
      fullPath: '/articles'
      preLoaderRoute: typeof AuthenticatedArticlesIndexLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/categories/': {
      id: '/_authenticated/categories/'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof AuthenticatedCategoriesIndexLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/chats/': {
      id: '/_authenticated/chats/'
      path: '/chats'
      fullPath: '/chats'
      preLoaderRoute: typeof AuthenticatedChatsIndexLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/colors/': {
      id: '/_authenticated/colors/'
      path: '/colors'
      fullPath: '/colors'
      preLoaderRoute: typeof AuthenticatedColorsIndexLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/content-categories/': {
      id: '/_authenticated/content-categories/'
      path: '/content-categories'
      fullPath: '/content-categories'
      preLoaderRoute: typeof AuthenticatedContentCategoriesIndexLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/event-categories/': {
      id: '/_authenticated/event-categories/'
      path: '/event-categories'
      fullPath: '/event-categories'
      preLoaderRoute: typeof AuthenticatedEventCategoriesIndexLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/events/': {
      id: '/_authenticated/events/'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof AuthenticatedEventsIndexLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/flash-sales-inventory/': {
      id: '/_authenticated/flash-sales-inventory/'
      path: '/'
      fullPath: '/flash-sales-inventory/'
      preLoaderRoute: typeof AuthenticatedFlashSalesInventoryIndexLazyImport
      parentRoute: typeof AuthenticatedFlashSalesInventoryRouteImport
    }
    '/_authenticated/flash-sales/': {
      id: '/_authenticated/flash-sales/'
      path: '/'
      fullPath: '/flash-sales/'
      preLoaderRoute: typeof AuthenticatedFlashSalesIndexLazyImport
      parentRoute: typeof AuthenticatedFlashSalesRouteImport
    }
    '/_authenticated/help-center/': {
      id: '/_authenticated/help-center/'
      path: '/help-center'
      fullPath: '/help-center'
      preLoaderRoute: typeof AuthenticatedHelpCenterIndexLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/inventories/': {
      id: '/_authenticated/inventories/'
      path: '/'
      fullPath: '/inventories/'
      preLoaderRoute: typeof AuthenticatedInventoriesIndexLazyImport
      parentRoute: typeof AuthenticatedInventoriesRouteImport
    }
    '/_authenticated/minigames/': {
      id: '/_authenticated/minigames/'
      path: '/'
      fullPath: '/minigames/'
      preLoaderRoute: typeof AuthenticatedMinigamesIndexLazyImport
      parentRoute: typeof AuthenticatedMinigamesRouteImport
    }
    '/_authenticated/order-shipping/': {
      id: '/_authenticated/order-shipping/'
      path: '/order-shipping'
      fullPath: '/order-shipping'
      preLoaderRoute: typeof AuthenticatedOrderShippingIndexLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/orders/': {
      id: '/_authenticated/orders/'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AuthenticatedOrdersIndexLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/payment-transactions/': {
      id: '/_authenticated/payment-transactions/'
      path: '/'
      fullPath: '/payment-transactions/'
      preLoaderRoute: typeof AuthenticatedPaymentTransactionsIndexLazyImport
      parentRoute: typeof AuthenticatedPaymentTransactionsRouteImport
    }
    '/_authenticated/products/': {
      id: '/_authenticated/products/'
      path: '/'
      fullPath: '/products/'
      preLoaderRoute: typeof AuthenticatedProductsIndexLazyImport
      parentRoute: typeof AuthenticatedProductsRouteImport
    }
    '/_authenticated/ratings/': {
      id: '/_authenticated/ratings/'
      path: '/'
      fullPath: '/ratings/'
      preLoaderRoute: typeof AuthenticatedRatingsIndexLazyImport
      parentRoute: typeof AuthenticatedRatingsRouteImport
    }
    '/_authenticated/referral/': {
      id: '/_authenticated/referral/'
      path: '/referral'
      fullPath: '/referral'
      preLoaderRoute: typeof AuthenticatedReferralIndexLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexLazyImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyImport
    }
    '/_authenticated/tasks/': {
      id: '/_authenticated/tasks/'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AuthenticatedTasksIndexLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/user-management/': {
      id: '/_authenticated/user-management/'
      path: '/user-management'
      fullPath: '/user-management'
      preLoaderRoute: typeof AuthenticatedUserManagementIndexLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/voucher-types/': {
      id: '/_authenticated/voucher-types/'
      path: '/'
      fullPath: '/voucher-types/'
      preLoaderRoute: typeof AuthenticatedVoucherTypesIndexLazyImport
      parentRoute: typeof AuthenticatedVoucherTypesRouteImport
    }
    '/_authenticated/vouchers/': {
      id: '/_authenticated/vouchers/'
      path: '/'
      fullPath: '/vouchers/'
      preLoaderRoute: typeof AuthenticatedVouchersIndexLazyImport
      parentRoute: typeof AuthenticatedVouchersRouteImport
    }
    '/_authenticated/messaging/ott/create': {
      id: '/_authenticated/messaging/ott/create'
      path: '/messaging/ott/create'
      fullPath: '/messaging/ott/create'
      preLoaderRoute: typeof AuthenticatedMessagingOttCreateLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_admin/admin/agencies/': {
      id: '/_admin/admin/agencies/'
      path: '/admin/agencies'
      fullPath: '/admin/agencies'
      preLoaderRoute: typeof AdminAdminAgenciesIndexImport
      parentRoute: typeof AdminRouteImport
    }
    '/_admin/admin/organizations/': {
      id: '/_admin/admin/organizations/'
      path: '/admin/organizations'
      fullPath: '/admin/organizations'
      preLoaderRoute: typeof AdminAdminOrganizationsIndexImport
      parentRoute: typeof AdminRouteImport
    }
    '/_authenticated/forms/$formId/': {
      id: '/_authenticated/forms/$formId/'
      path: '/$formId'
      fullPath: '/forms/$formId'
      preLoaderRoute: typeof AuthenticatedFormsFormIdIndexImport
      parentRoute: typeof AuthenticatedFormsRouteImport
    }
    '/_authenticated/forms/create/': {
      id: '/_authenticated/forms/create/'
      path: '/create'
      fullPath: '/forms/create'
      preLoaderRoute: typeof AuthenticatedFormsCreateIndexImport
      parentRoute: typeof AuthenticatedFormsRouteImport
    }
    '/_authenticated/surveys/$surveyId/': {
      id: '/_authenticated/surveys/$surveyId/'
      path: '/$surveyId'
      fullPath: '/surveys/$surveyId'
      preLoaderRoute: typeof AuthenticatedSurveysSurveyIdIndexImport
      parentRoute: typeof AuthenticatedSurveysRouteImport
    }
    '/_authenticated/surveys/create/': {
      id: '/_authenticated/surveys/create/'
      path: '/create'
      fullPath: '/surveys/create'
      preLoaderRoute: typeof AuthenticatedSurveysCreateIndexImport
      parentRoute: typeof AuthenticatedSurveysRouteImport
    }
    '/_admin/admin/business-config/': {
      id: '/_admin/admin/business-config/'
      path: '/admin/business-config'
      fullPath: '/admin/business-config'
      preLoaderRoute: typeof AdminAdminBusinessConfigIndexLazyImport
      parentRoute: typeof AdminRouteImport
    }
    '/_admin/admin/feature-flags/': {
      id: '/_admin/admin/feature-flags/'
      path: '/admin/feature-flags'
      fullPath: '/admin/feature-flags'
      preLoaderRoute: typeof AdminAdminFeatureFlagsIndexLazyImport
      parentRoute: typeof AdminRouteImport
    }
    '/_admin/admin/feature-management/': {
      id: '/_admin/admin/feature-management/'
      path: '/admin/feature-management'
      fullPath: '/admin/feature-management'
      preLoaderRoute: typeof AdminAdminFeatureManagementIndexLazyImport
      parentRoute: typeof AdminRouteImport
    }
    '/_admin/admin/sdui/': {
      id: '/_admin/admin/sdui/'
      path: '/admin/sdui'
      fullPath: '/admin/sdui'
      preLoaderRoute: typeof AdminAdminSduiIndexLazyImport
      parentRoute: typeof AdminRouteImport
    }
    '/_admin/admin/templates/': {
      id: '/_admin/admin/templates/'
      path: '/admin/templates'
      fullPath: '/admin/templates'
      preLoaderRoute: typeof AdminAdminTemplatesIndexLazyImport
      parentRoute: typeof AdminRouteImport
    }
    '/_admin/admin/tenants/': {
      id: '/_admin/admin/tenants/'
      path: '/admin/tenants'
      fullPath: '/admin/tenants'
      preLoaderRoute: typeof AdminAdminTenantsIndexLazyImport
      parentRoute: typeof AdminRouteImport
    }
    '/_admin/admin/users/': {
      id: '/_admin/admin/users/'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminAdminUsersIndexLazyImport
      parentRoute: typeof AdminRouteImport
    }
    '/_authenticated/articles/$articleId/': {
      id: '/_authenticated/articles/$articleId/'
      path: '/articles/$articleId'
      fullPath: '/articles/$articleId'
      preLoaderRoute: typeof AuthenticatedArticlesArticleIdIndexLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/articles/create/': {
      id: '/_authenticated/articles/create/'
      path: '/articles/create'
      fullPath: '/articles/create'
      preLoaderRoute: typeof AuthenticatedArticlesCreateIndexLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/events/$eventId/': {
      id: '/_authenticated/events/$eventId/'
      path: '/events/$eventId'
      fullPath: '/events/$eventId'
      preLoaderRoute: typeof AuthenticatedEventsEventIdIndexLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/events/create/': {
      id: '/_authenticated/events/create/'
      path: '/events/create'
      fullPath: '/events/create'
      preLoaderRoute: typeof AuthenticatedEventsCreateIndexLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/fns-responses/$responseId/': {
      id: '/_authenticated/fns-responses/$responseId/'
      path: '/$responseId'
      fullPath: '/fns-responses/$responseId'
      preLoaderRoute: typeof AuthenticatedFnsResponsesResponseIdIndexLazyImport
      parentRoute: typeof AuthenticatedFnsResponsesRouteImport
    }
    '/_authenticated/inventories/$inventoryId/': {
      id: '/_authenticated/inventories/$inventoryId/'
      path: '/$inventoryId'
      fullPath: '/inventories/$inventoryId'
      preLoaderRoute: typeof AuthenticatedInventoriesInventoryIdIndexLazyImport
      parentRoute: typeof AuthenticatedInventoriesRouteImport
    }
    '/_authenticated/minigames/$campaignId/': {
      id: '/_authenticated/minigames/$campaignId/'
      path: '/$campaignId'
      fullPath: '/minigames/$campaignId'
      preLoaderRoute: typeof AuthenticatedMinigamesCampaignIdIndexLazyImport
      parentRoute: typeof AuthenticatedMinigamesRouteImport
    }
    '/_authenticated/payment-transactions/$transactionId/': {
      id: '/_authenticated/payment-transactions/$transactionId/'
      path: '/$transactionId'
      fullPath: '/payment-transactions/$transactionId'
      preLoaderRoute: typeof AuthenticatedPaymentTransactionsTransactionIdIndexLazyImport
      parentRoute: typeof AuthenticatedPaymentTransactionsRouteImport
    }
    '/_authenticated/products/$productId/': {
      id: '/_authenticated/products/$productId/'
      path: '/$productId'
      fullPath: '/products/$productId'
      preLoaderRoute: typeof AuthenticatedProductsProductIdIndexLazyImport
      parentRoute: typeof AuthenticatedProductsRouteImport
    }
    '/_authenticated/products/create/': {
      id: '/_authenticated/products/create/'
      path: '/create'
      fullPath: '/products/create'
      preLoaderRoute: typeof AuthenticatedProductsCreateIndexLazyImport
      parentRoute: typeof AuthenticatedProductsRouteImport
    }
    '/_authenticated/voucher-types/$voucherTypeId/': {
      id: '/_authenticated/voucher-types/$voucherTypeId/'
      path: '/$voucherTypeId'
      fullPath: '/voucher-types/$voucherTypeId'
      preLoaderRoute: typeof AuthenticatedVoucherTypesVoucherTypeIdIndexLazyImport
      parentRoute: typeof AuthenticatedVoucherTypesRouteImport
    }
    '/_authenticated/voucher-types/create/': {
      id: '/_authenticated/voucher-types/create/'
      path: '/create'
      fullPath: '/voucher-types/create'
      preLoaderRoute: typeof AuthenticatedVoucherTypesCreateIndexLazyImport
      parentRoute: typeof AuthenticatedVoucherTypesRouteImport
    }
    '/_authenticated/vouchers/$voucherId/': {
      id: '/_authenticated/vouchers/$voucherId/'
      path: '/$voucherId'
      fullPath: '/vouchers/$voucherId'
      preLoaderRoute: typeof AuthenticatedVouchersVoucherIdIndexLazyImport
      parentRoute: typeof AuthenticatedVouchersRouteImport
    }
    '/_authenticated/vouchers/create/': {
      id: '/_authenticated/vouchers/create/'
      path: '/create'
      fullPath: '/vouchers/create'
      preLoaderRoute: typeof AuthenticatedVouchersCreateIndexLazyImport
      parentRoute: typeof AuthenticatedVouchersRouteImport
    }
    '/_authenticated/message-management/ott/create/create': {
      id: '/_authenticated/message-management/ott/create/create'
      path: '/message-management/ott/create/create'
      fullPath: '/message-management/ott/create/create'
      preLoaderRoute: typeof AuthenticatedMessageManagementOttCreateCreateLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_admin/admin/templates/$templateId/': {
      id: '/_admin/admin/templates/$templateId/'
      path: '/admin/templates/$templateId'
      fullPath: '/admin/templates/$templateId'
      preLoaderRoute: typeof AdminAdminTemplatesTemplateIdIndexImport
      parentRoute: typeof AdminRouteImport
    }
    '/_admin/admin/templates/create/': {
      id: '/_admin/admin/templates/create/'
      path: '/admin/templates/create'
      fullPath: '/admin/templates/create'
      preLoaderRoute: typeof AdminAdminTemplatesCreateIndexImport
      parentRoute: typeof AdminRouteImport
    }
    '/_authenticated/forms/$formId/edit/': {
      id: '/_authenticated/forms/$formId/edit/'
      path: '/$formId/edit'
      fullPath: '/forms/$formId/edit'
      preLoaderRoute: typeof AuthenticatedFormsFormIdEditIndexImport
      parentRoute: typeof AuthenticatedFormsRouteImport
    }
    '/_authenticated/surveys/$surveyId/edit/': {
      id: '/_authenticated/surveys/$surveyId/edit/'
      path: '/$surveyId/edit'
      fullPath: '/surveys/$surveyId/edit'
      preLoaderRoute: typeof AuthenticatedSurveysSurveyIdEditIndexImport
      parentRoute: typeof AuthenticatedSurveysRouteImport
    }
    '/_admin/admin/api-hub/global-credentials/': {
      id: '/_admin/admin/api-hub/global-credentials/'
      path: '/admin/api-hub/global-credentials'
      fullPath: '/admin/api-hub/global-credentials'
      preLoaderRoute: typeof AdminAdminApiHubGlobalCredentialsIndexLazyImport
      parentRoute: typeof AdminRouteImport
    }
    '/_admin/admin/business-config/$configId/': {
      id: '/_admin/admin/business-config/$configId/'
      path: '/admin/business-config/$configId'
      fullPath: '/admin/business-config/$configId'
      preLoaderRoute: typeof AdminAdminBusinessConfigConfigIdIndexLazyImport
      parentRoute: typeof AdminRouteImport
    }
    '/_admin/admin/business-config/create/': {
      id: '/_admin/admin/business-config/create/'
      path: '/admin/business-config/create'
      fullPath: '/admin/business-config/create'
      preLoaderRoute: typeof AdminAdminBusinessConfigCreateIndexLazyImport
      parentRoute: typeof AdminRouteImport
    }
    '/_admin/admin/business-config/test/': {
      id: '/_admin/admin/business-config/test/'
      path: '/admin/business-config/test'
      fullPath: '/admin/business-config/test'
      preLoaderRoute: typeof AdminAdminBusinessConfigTestIndexLazyImport
      parentRoute: typeof AdminRouteImport
    }
    '/_admin/admin/feature-flags/$featureFlagId/': {
      id: '/_admin/admin/feature-flags/$featureFlagId/'
      path: '/admin/feature-flags/$featureFlagId'
      fullPath: '/admin/feature-flags/$featureFlagId'
      preLoaderRoute: typeof AdminAdminFeatureFlagsFeatureFlagIdIndexLazyImport
      parentRoute: typeof AdminRouteImport
    }
    '/_admin/admin/feature-flags/common/': {
      id: '/_admin/admin/feature-flags/common/'
      path: '/admin/feature-flags/common'
      fullPath: '/admin/feature-flags/common'
      preLoaderRoute: typeof AdminAdminFeatureFlagsCommonIndexLazyImport
      parentRoute: typeof AdminRouteImport
    }
    '/_admin/admin/feature-flags/tenant-overrides/': {
      id: '/_admin/admin/feature-flags/tenant-overrides/'
      path: '/admin/feature-flags/tenant-overrides'
      fullPath: '/admin/feature-flags/tenant-overrides'
      preLoaderRoute: typeof AdminAdminFeatureFlagsTenantOverridesIndexLazyImport
      parentRoute: typeof AdminRouteImport
    }
    '/_admin/admin/feature-flags/tenant/': {
      id: '/_admin/admin/feature-flags/tenant/'
      path: '/admin/feature-flags/tenant'
      fullPath: '/admin/feature-flags/tenant'
      preLoaderRoute: typeof AdminAdminFeatureFlagsTenantIndexLazyImport
      parentRoute: typeof AdminRouteImport
    }
    '/_admin/admin/sdui/$sduiId/': {
      id: '/_admin/admin/sdui/$sduiId/'
      path: '/admin/sdui/$sduiId'
      fullPath: '/admin/sdui/$sduiId'
      preLoaderRoute: typeof AdminAdminSduiSduiIdIndexLazyImport
      parentRoute: typeof AdminRouteImport
    }
    '/_authenticated/articles/$articleId/edit/': {
      id: '/_authenticated/articles/$articleId/edit/'
      path: '/articles/$articleId/edit'
      fullPath: '/articles/$articleId/edit'
      preLoaderRoute: typeof AuthenticatedArticlesArticleIdEditIndexLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/events/$eventId/edit/': {
      id: '/_authenticated/events/$eventId/edit/'
      path: '/events/$eventId/edit'
      fullPath: '/events/$eventId/edit'
      preLoaderRoute: typeof AuthenticatedEventsEventIdEditIndexLazyImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/minigames/$campaignId/edit/': {
      id: '/_authenticated/minigames/$campaignId/edit/'
      path: '/$campaignId/edit'
      fullPath: '/minigames/$campaignId/edit'
      preLoaderRoute: typeof AuthenticatedMinigamesCampaignIdEditIndexLazyImport
      parentRoute: typeof AuthenticatedMinigamesRouteImport
    }
    '/_authenticated/products/$productId/edit/': {
      id: '/_authenticated/products/$productId/edit/'
      path: '/$productId/edit'
      fullPath: '/products/$productId/edit'
      preLoaderRoute: typeof AuthenticatedProductsProductIdEditIndexLazyImport
      parentRoute: typeof AuthenticatedProductsRouteImport
    }
    '/_authenticated/voucher-types/$voucherTypeId/edit/': {
      id: '/_authenticated/voucher-types/$voucherTypeId/edit/'
      path: '/$voucherTypeId/edit'
      fullPath: '/voucher-types/$voucherTypeId/edit'
      preLoaderRoute: typeof AuthenticatedVoucherTypesVoucherTypeIdEditIndexLazyImport
      parentRoute: typeof AuthenticatedVoucherTypesRouteImport
    }
    '/_authenticated/vouchers/$voucherId/edit/': {
      id: '/_authenticated/vouchers/$voucherId/edit/'
      path: '/$voucherId/edit'
      fullPath: '/vouchers/$voucherId/edit'
      preLoaderRoute: typeof AuthenticatedVouchersVoucherIdEditIndexLazyImport
      parentRoute: typeof AuthenticatedVouchersRouteImport
    }
    '/_admin/admin/templates/$templateId/$versionId/': {
      id: '/_admin/admin/templates/$templateId/$versionId/'
      path: '/admin/templates/$templateId/$versionId'
      fullPath: '/admin/templates/$templateId/$versionId'
      preLoaderRoute: typeof AdminAdminTemplatesTemplateIdVersionIdIndexImport
      parentRoute: typeof AdminRouteImport
    }
    '/_admin/admin/business-config/$configId/edit/': {
      id: '/_admin/admin/business-config/$configId/edit/'
      path: '/admin/business-config/$configId/edit'
      fullPath: '/admin/business-config/$configId/edit'
      preLoaderRoute: typeof AdminAdminBusinessConfigConfigIdEditIndexLazyImport
      parentRoute: typeof AdminRouteImport
    }
    '/_admin/admin/templates/$templateId/version/$versionId/': {
      id: '/_admin/admin/templates/$templateId/version/$versionId/'
      path: '/admin/templates/$templateId/version/$versionId'
      fullPath: '/admin/templates/$templateId/version/$versionId'
      preLoaderRoute: typeof AdminAdminTemplatesTemplateIdVersionVersionIdIndexImport
      parentRoute: typeof AdminRouteImport
    }
  }
}

// Create and export the route tree

interface AdminRouteRouteChildren {
  AdminAdminIndexRoute: typeof AdminAdminIndexRoute
  AdminAdminAgenciesIndexRoute: typeof AdminAdminAgenciesIndexRoute
  AdminAdminOrganizationsIndexRoute: typeof AdminAdminOrganizationsIndexRoute
  AdminAdminBusinessConfigIndexLazyRoute: typeof AdminAdminBusinessConfigIndexLazyRoute
  AdminAdminFeatureFlagsIndexLazyRoute: typeof AdminAdminFeatureFlagsIndexLazyRoute
  AdminAdminFeatureManagementIndexLazyRoute: typeof AdminAdminFeatureManagementIndexLazyRoute
  AdminAdminSduiIndexLazyRoute: typeof AdminAdminSduiIndexLazyRoute
  AdminAdminTemplatesIndexLazyRoute: typeof AdminAdminTemplatesIndexLazyRoute
  AdminAdminTenantsIndexLazyRoute: typeof AdminAdminTenantsIndexLazyRoute
  AdminAdminUsersIndexLazyRoute: typeof AdminAdminUsersIndexLazyRoute
  AdminAdminTemplatesTemplateIdIndexRoute: typeof AdminAdminTemplatesTemplateIdIndexRoute
  AdminAdminTemplatesCreateIndexRoute: typeof AdminAdminTemplatesCreateIndexRoute
  AdminAdminApiHubGlobalCredentialsIndexLazyRoute: typeof AdminAdminApiHubGlobalCredentialsIndexLazyRoute
  AdminAdminBusinessConfigConfigIdIndexLazyRoute: typeof AdminAdminBusinessConfigConfigIdIndexLazyRoute
  AdminAdminBusinessConfigCreateIndexLazyRoute: typeof AdminAdminBusinessConfigCreateIndexLazyRoute
  AdminAdminBusinessConfigTestIndexLazyRoute: typeof AdminAdminBusinessConfigTestIndexLazyRoute
  AdminAdminFeatureFlagsFeatureFlagIdIndexLazyRoute: typeof AdminAdminFeatureFlagsFeatureFlagIdIndexLazyRoute
  AdminAdminFeatureFlagsCommonIndexLazyRoute: typeof AdminAdminFeatureFlagsCommonIndexLazyRoute
  AdminAdminFeatureFlagsTenantOverridesIndexLazyRoute: typeof AdminAdminFeatureFlagsTenantOverridesIndexLazyRoute
  AdminAdminFeatureFlagsTenantIndexLazyRoute: typeof AdminAdminFeatureFlagsTenantIndexLazyRoute
  AdminAdminSduiSduiIdIndexLazyRoute: typeof AdminAdminSduiSduiIdIndexLazyRoute
  AdminAdminTemplatesTemplateIdVersionIdIndexRoute: typeof AdminAdminTemplatesTemplateIdVersionIdIndexRoute
  AdminAdminBusinessConfigConfigIdEditIndexLazyRoute: typeof AdminAdminBusinessConfigConfigIdEditIndexLazyRoute
  AdminAdminTemplatesTemplateIdVersionVersionIdIndexRoute: typeof AdminAdminTemplatesTemplateIdVersionVersionIdIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminAdminIndexRoute: AdminAdminIndexRoute,
  AdminAdminAgenciesIndexRoute: AdminAdminAgenciesIndexRoute,
  AdminAdminOrganizationsIndexRoute: AdminAdminOrganizationsIndexRoute,
  AdminAdminBusinessConfigIndexLazyRoute:
    AdminAdminBusinessConfigIndexLazyRoute,
  AdminAdminFeatureFlagsIndexLazyRoute: AdminAdminFeatureFlagsIndexLazyRoute,
  AdminAdminFeatureManagementIndexLazyRoute:
    AdminAdminFeatureManagementIndexLazyRoute,
  AdminAdminSduiIndexLazyRoute: AdminAdminSduiIndexLazyRoute,
  AdminAdminTemplatesIndexLazyRoute: AdminAdminTemplatesIndexLazyRoute,
  AdminAdminTenantsIndexLazyRoute: AdminAdminTenantsIndexLazyRoute,
  AdminAdminUsersIndexLazyRoute: AdminAdminUsersIndexLazyRoute,
  AdminAdminTemplatesTemplateIdIndexRoute:
    AdminAdminTemplatesTemplateIdIndexRoute,
  AdminAdminTemplatesCreateIndexRoute: AdminAdminTemplatesCreateIndexRoute,
  AdminAdminApiHubGlobalCredentialsIndexLazyRoute:
    AdminAdminApiHubGlobalCredentialsIndexLazyRoute,
  AdminAdminBusinessConfigConfigIdIndexLazyRoute:
    AdminAdminBusinessConfigConfigIdIndexLazyRoute,
  AdminAdminBusinessConfigCreateIndexLazyRoute:
    AdminAdminBusinessConfigCreateIndexLazyRoute,
  AdminAdminBusinessConfigTestIndexLazyRoute:
    AdminAdminBusinessConfigTestIndexLazyRoute,
  AdminAdminFeatureFlagsFeatureFlagIdIndexLazyRoute:
    AdminAdminFeatureFlagsFeatureFlagIdIndexLazyRoute,
  AdminAdminFeatureFlagsCommonIndexLazyRoute:
    AdminAdminFeatureFlagsCommonIndexLazyRoute,
  AdminAdminFeatureFlagsTenantOverridesIndexLazyRoute:
    AdminAdminFeatureFlagsTenantOverridesIndexLazyRoute,
  AdminAdminFeatureFlagsTenantIndexLazyRoute:
    AdminAdminFeatureFlagsTenantIndexLazyRoute,
  AdminAdminSduiSduiIdIndexLazyRoute: AdminAdminSduiSduiIdIndexLazyRoute,
  AdminAdminTemplatesTemplateIdVersionIdIndexRoute:
    AdminAdminTemplatesTemplateIdVersionIdIndexRoute,
  AdminAdminBusinessConfigConfigIdEditIndexLazyRoute:
    AdminAdminBusinessConfigConfigIdEditIndexLazyRoute,
  AdminAdminTemplatesTemplateIdVersionVersionIdIndexRoute:
    AdminAdminTemplatesTemplateIdVersionVersionIdIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface AuthenticatedFlashSalesRouteRouteChildren {
  AuthenticatedFlashSalesIndexLazyRoute: typeof AuthenticatedFlashSalesIndexLazyRoute
}

const AuthenticatedFlashSalesRouteRouteChildren: AuthenticatedFlashSalesRouteRouteChildren =
  {
    AuthenticatedFlashSalesIndexLazyRoute:
      AuthenticatedFlashSalesIndexLazyRoute,
  }

const AuthenticatedFlashSalesRouteRouteWithChildren =
  AuthenticatedFlashSalesRouteRoute._addFileChildren(
    AuthenticatedFlashSalesRouteRouteChildren,
  )

interface AuthenticatedFlashSalesInventoryRouteRouteChildren {
  AuthenticatedFlashSalesInventoryCampaignIdLazyRoute: typeof AuthenticatedFlashSalesInventoryCampaignIdLazyRoute
  AuthenticatedFlashSalesInventoryIndexLazyRoute: typeof AuthenticatedFlashSalesInventoryIndexLazyRoute
}

const AuthenticatedFlashSalesInventoryRouteRouteChildren: AuthenticatedFlashSalesInventoryRouteRouteChildren =
  {
    AuthenticatedFlashSalesInventoryCampaignIdLazyRoute:
      AuthenticatedFlashSalesInventoryCampaignIdLazyRoute,
    AuthenticatedFlashSalesInventoryIndexLazyRoute:
      AuthenticatedFlashSalesInventoryIndexLazyRoute,
  }

const AuthenticatedFlashSalesInventoryRouteRouteWithChildren =
  AuthenticatedFlashSalesInventoryRouteRoute._addFileChildren(
    AuthenticatedFlashSalesInventoryRouteRouteChildren,
  )

interface AuthenticatedFnsResponsesRouteRouteChildren {
  AuthenticatedFnsResponsesIndexRoute: typeof AuthenticatedFnsResponsesIndexRoute
  AuthenticatedFnsResponsesResponseIdIndexLazyRoute: typeof AuthenticatedFnsResponsesResponseIdIndexLazyRoute
}

const AuthenticatedFnsResponsesRouteRouteChildren: AuthenticatedFnsResponsesRouteRouteChildren =
  {
    AuthenticatedFnsResponsesIndexRoute: AuthenticatedFnsResponsesIndexRoute,
    AuthenticatedFnsResponsesResponseIdIndexLazyRoute:
      AuthenticatedFnsResponsesResponseIdIndexLazyRoute,
  }

const AuthenticatedFnsResponsesRouteRouteWithChildren =
  AuthenticatedFnsResponsesRouteRoute._addFileChildren(
    AuthenticatedFnsResponsesRouteRouteChildren,
  )

interface AuthenticatedFormsRouteRouteChildren {
  AuthenticatedFormsIndexRoute: typeof AuthenticatedFormsIndexRoute
  AuthenticatedFormsFormIdIndexRoute: typeof AuthenticatedFormsFormIdIndexRoute
  AuthenticatedFormsCreateIndexRoute: typeof AuthenticatedFormsCreateIndexRoute
  AuthenticatedFormsFormIdEditIndexRoute: typeof AuthenticatedFormsFormIdEditIndexRoute
}

const AuthenticatedFormsRouteRouteChildren: AuthenticatedFormsRouteRouteChildren =
  {
    AuthenticatedFormsIndexRoute: AuthenticatedFormsIndexRoute,
    AuthenticatedFormsFormIdIndexRoute: AuthenticatedFormsFormIdIndexRoute,
    AuthenticatedFormsCreateIndexRoute: AuthenticatedFormsCreateIndexRoute,
    AuthenticatedFormsFormIdEditIndexRoute:
      AuthenticatedFormsFormIdEditIndexRoute,
  }

const AuthenticatedFormsRouteRouteWithChildren =
  AuthenticatedFormsRouteRoute._addFileChildren(
    AuthenticatedFormsRouteRouteChildren,
  )

interface AuthenticatedInventoriesRouteRouteChildren {
  AuthenticatedInventoriesIndexLazyRoute: typeof AuthenticatedInventoriesIndexLazyRoute
  AuthenticatedInventoriesInventoryIdIndexLazyRoute: typeof AuthenticatedInventoriesInventoryIdIndexLazyRoute
}

const AuthenticatedInventoriesRouteRouteChildren: AuthenticatedInventoriesRouteRouteChildren =
  {
    AuthenticatedInventoriesIndexLazyRoute:
      AuthenticatedInventoriesIndexLazyRoute,
    AuthenticatedInventoriesInventoryIdIndexLazyRoute:
      AuthenticatedInventoriesInventoryIdIndexLazyRoute,
  }

const AuthenticatedInventoriesRouteRouteWithChildren =
  AuthenticatedInventoriesRouteRoute._addFileChildren(
    AuthenticatedInventoriesRouteRouteChildren,
  )

interface AuthenticatedMinigamesRouteRouteChildren {
  AuthenticatedMinigamesCreateLazyRoute: typeof AuthenticatedMinigamesCreateLazyRoute
  AuthenticatedMinigamesTemplatesLazyRoute: typeof AuthenticatedMinigamesTemplatesLazyRoute
  AuthenticatedMinigamesIndexLazyRoute: typeof AuthenticatedMinigamesIndexLazyRoute
  AuthenticatedMinigamesCampaignIdIndexLazyRoute: typeof AuthenticatedMinigamesCampaignIdIndexLazyRoute
  AuthenticatedMinigamesCampaignIdEditIndexLazyRoute: typeof AuthenticatedMinigamesCampaignIdEditIndexLazyRoute
}

const AuthenticatedMinigamesRouteRouteChildren: AuthenticatedMinigamesRouteRouteChildren =
  {
    AuthenticatedMinigamesCreateLazyRoute:
      AuthenticatedMinigamesCreateLazyRoute,
    AuthenticatedMinigamesTemplatesLazyRoute:
      AuthenticatedMinigamesTemplatesLazyRoute,
    AuthenticatedMinigamesIndexLazyRoute: AuthenticatedMinigamesIndexLazyRoute,
    AuthenticatedMinigamesCampaignIdIndexLazyRoute:
      AuthenticatedMinigamesCampaignIdIndexLazyRoute,
    AuthenticatedMinigamesCampaignIdEditIndexLazyRoute:
      AuthenticatedMinigamesCampaignIdEditIndexLazyRoute,
  }

const AuthenticatedMinigamesRouteRouteWithChildren =
  AuthenticatedMinigamesRouteRoute._addFileChildren(
    AuthenticatedMinigamesRouteRouteChildren,
  )

interface AuthenticatedPaymentTransactionsRouteRouteChildren {
  AuthenticatedPaymentTransactionsIndexLazyRoute: typeof AuthenticatedPaymentTransactionsIndexLazyRoute
  AuthenticatedPaymentTransactionsTransactionIdIndexLazyRoute: typeof AuthenticatedPaymentTransactionsTransactionIdIndexLazyRoute
}

const AuthenticatedPaymentTransactionsRouteRouteChildren: AuthenticatedPaymentTransactionsRouteRouteChildren =
  {
    AuthenticatedPaymentTransactionsIndexLazyRoute:
      AuthenticatedPaymentTransactionsIndexLazyRoute,
    AuthenticatedPaymentTransactionsTransactionIdIndexLazyRoute:
      AuthenticatedPaymentTransactionsTransactionIdIndexLazyRoute,
  }

const AuthenticatedPaymentTransactionsRouteRouteWithChildren =
  AuthenticatedPaymentTransactionsRouteRoute._addFileChildren(
    AuthenticatedPaymentTransactionsRouteRouteChildren,
  )

interface AuthenticatedProductsRouteRouteChildren {
  AuthenticatedProductsIndexLazyRoute: typeof AuthenticatedProductsIndexLazyRoute
  AuthenticatedProductsProductIdIndexLazyRoute: typeof AuthenticatedProductsProductIdIndexLazyRoute
  AuthenticatedProductsCreateIndexLazyRoute: typeof AuthenticatedProductsCreateIndexLazyRoute
  AuthenticatedProductsProductIdEditIndexLazyRoute: typeof AuthenticatedProductsProductIdEditIndexLazyRoute
}

const AuthenticatedProductsRouteRouteChildren: AuthenticatedProductsRouteRouteChildren =
  {
    AuthenticatedProductsIndexLazyRoute: AuthenticatedProductsIndexLazyRoute,
    AuthenticatedProductsProductIdIndexLazyRoute:
      AuthenticatedProductsProductIdIndexLazyRoute,
    AuthenticatedProductsCreateIndexLazyRoute:
      AuthenticatedProductsCreateIndexLazyRoute,
    AuthenticatedProductsProductIdEditIndexLazyRoute:
      AuthenticatedProductsProductIdEditIndexLazyRoute,
  }

const AuthenticatedProductsRouteRouteWithChildren =
  AuthenticatedProductsRouteRoute._addFileChildren(
    AuthenticatedProductsRouteRouteChildren,
  )

interface AuthenticatedRatingsRouteRouteChildren {
  AuthenticatedRatingsIndexLazyRoute: typeof AuthenticatedRatingsIndexLazyRoute
}

const AuthenticatedRatingsRouteRouteChildren: AuthenticatedRatingsRouteRouteChildren =
  {
    AuthenticatedRatingsIndexLazyRoute: AuthenticatedRatingsIndexLazyRoute,
  }

const AuthenticatedRatingsRouteRouteWithChildren =
  AuthenticatedRatingsRouteRoute._addFileChildren(
    AuthenticatedRatingsRouteRouteChildren,
  )

interface AuthenticatedSurveysRouteRouteChildren {
  AuthenticatedSurveysIndexRoute: typeof AuthenticatedSurveysIndexRoute
  AuthenticatedSurveysSurveyIdIndexRoute: typeof AuthenticatedSurveysSurveyIdIndexRoute
  AuthenticatedSurveysCreateIndexRoute: typeof AuthenticatedSurveysCreateIndexRoute
  AuthenticatedSurveysSurveyIdEditIndexRoute: typeof AuthenticatedSurveysSurveyIdEditIndexRoute
}

const AuthenticatedSurveysRouteRouteChildren: AuthenticatedSurveysRouteRouteChildren =
  {
    AuthenticatedSurveysIndexRoute: AuthenticatedSurveysIndexRoute,
    AuthenticatedSurveysSurveyIdIndexRoute:
      AuthenticatedSurveysSurveyIdIndexRoute,
    AuthenticatedSurveysCreateIndexRoute: AuthenticatedSurveysCreateIndexRoute,
    AuthenticatedSurveysSurveyIdEditIndexRoute:
      AuthenticatedSurveysSurveyIdEditIndexRoute,
  }

const AuthenticatedSurveysRouteRouteWithChildren =
  AuthenticatedSurveysRouteRoute._addFileChildren(
    AuthenticatedSurveysRouteRouteChildren,
  )

interface AuthenticatedVoucherTypesRouteRouteChildren {
  AuthenticatedVoucherTypesIndexLazyRoute: typeof AuthenticatedVoucherTypesIndexLazyRoute
  AuthenticatedVoucherTypesVoucherTypeIdIndexLazyRoute: typeof AuthenticatedVoucherTypesVoucherTypeIdIndexLazyRoute
  AuthenticatedVoucherTypesCreateIndexLazyRoute: typeof AuthenticatedVoucherTypesCreateIndexLazyRoute
  AuthenticatedVoucherTypesVoucherTypeIdEditIndexLazyRoute: typeof AuthenticatedVoucherTypesVoucherTypeIdEditIndexLazyRoute
}

const AuthenticatedVoucherTypesRouteRouteChildren: AuthenticatedVoucherTypesRouteRouteChildren =
  {
    AuthenticatedVoucherTypesIndexLazyRoute:
      AuthenticatedVoucherTypesIndexLazyRoute,
    AuthenticatedVoucherTypesVoucherTypeIdIndexLazyRoute:
      AuthenticatedVoucherTypesVoucherTypeIdIndexLazyRoute,
    AuthenticatedVoucherTypesCreateIndexLazyRoute:
      AuthenticatedVoucherTypesCreateIndexLazyRoute,
    AuthenticatedVoucherTypesVoucherTypeIdEditIndexLazyRoute:
      AuthenticatedVoucherTypesVoucherTypeIdEditIndexLazyRoute,
  }

const AuthenticatedVoucherTypesRouteRouteWithChildren =
  AuthenticatedVoucherTypesRouteRoute._addFileChildren(
    AuthenticatedVoucherTypesRouteRouteChildren,
  )

interface AuthenticatedVouchersRouteRouteChildren {
  AuthenticatedVouchersIndexLazyRoute: typeof AuthenticatedVouchersIndexLazyRoute
  AuthenticatedVouchersVoucherIdIndexLazyRoute: typeof AuthenticatedVouchersVoucherIdIndexLazyRoute
  AuthenticatedVouchersCreateIndexLazyRoute: typeof AuthenticatedVouchersCreateIndexLazyRoute
  AuthenticatedVouchersVoucherIdEditIndexLazyRoute: typeof AuthenticatedVouchersVoucherIdEditIndexLazyRoute
}

const AuthenticatedVouchersRouteRouteChildren: AuthenticatedVouchersRouteRouteChildren =
  {
    AuthenticatedVouchersIndexLazyRoute: AuthenticatedVouchersIndexLazyRoute,
    AuthenticatedVouchersVoucherIdIndexLazyRoute:
      AuthenticatedVouchersVoucherIdIndexLazyRoute,
    AuthenticatedVouchersCreateIndexLazyRoute:
      AuthenticatedVouchersCreateIndexLazyRoute,
    AuthenticatedVouchersVoucherIdEditIndexLazyRoute:
      AuthenticatedVouchersVoucherIdEditIndexLazyRoute,
  }

const AuthenticatedVouchersRouteRouteWithChildren =
  AuthenticatedVouchersRouteRoute._addFileChildren(
    AuthenticatedVouchersRouteRouteChildren,
  )

interface AuthenticatedSettingsRouteLazyRouteChildren {
  AuthenticatedSettingsAccountLazyRoute: typeof AuthenticatedSettingsAccountLazyRoute
  AuthenticatedSettingsAppearanceLazyRoute: typeof AuthenticatedSettingsAppearanceLazyRoute
  AuthenticatedSettingsContentLazyRoute: typeof AuthenticatedSettingsContentLazyRoute
  AuthenticatedSettingsDisplayLazyRoute: typeof AuthenticatedSettingsDisplayLazyRoute
  AuthenticatedSettingsGeneralLazyRoute: typeof AuthenticatedSettingsGeneralLazyRoute
  AuthenticatedSettingsNotificationsLazyRoute: typeof AuthenticatedSettingsNotificationsLazyRoute
  AuthenticatedSettingsShippingLazyRoute: typeof AuthenticatedSettingsShippingLazyRoute
  AuthenticatedSettingsIndexLazyRoute: typeof AuthenticatedSettingsIndexLazyRoute
}

const AuthenticatedSettingsRouteLazyRouteChildren: AuthenticatedSettingsRouteLazyRouteChildren =
  {
    AuthenticatedSettingsAccountLazyRoute:
      AuthenticatedSettingsAccountLazyRoute,
    AuthenticatedSettingsAppearanceLazyRoute:
      AuthenticatedSettingsAppearanceLazyRoute,
    AuthenticatedSettingsContentLazyRoute:
      AuthenticatedSettingsContentLazyRoute,
    AuthenticatedSettingsDisplayLazyRoute:
      AuthenticatedSettingsDisplayLazyRoute,
    AuthenticatedSettingsGeneralLazyRoute:
      AuthenticatedSettingsGeneralLazyRoute,
    AuthenticatedSettingsNotificationsLazyRoute:
      AuthenticatedSettingsNotificationsLazyRoute,
    AuthenticatedSettingsShippingLazyRoute:
      AuthenticatedSettingsShippingLazyRoute,
    AuthenticatedSettingsIndexLazyRoute: AuthenticatedSettingsIndexLazyRoute,
  }

const AuthenticatedSettingsRouteLazyRouteWithChildren =
  AuthenticatedSettingsRouteLazyRoute._addFileChildren(
    AuthenticatedSettingsRouteLazyRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedFlashSalesRouteRoute: typeof AuthenticatedFlashSalesRouteRouteWithChildren
  AuthenticatedFlashSalesInventoryRouteRoute: typeof AuthenticatedFlashSalesInventoryRouteRouteWithChildren
  AuthenticatedFnsResponsesRouteRoute: typeof AuthenticatedFnsResponsesRouteRouteWithChildren
  AuthenticatedFormsRouteRoute: typeof AuthenticatedFormsRouteRouteWithChildren
  AuthenticatedInventoriesRouteRoute: typeof AuthenticatedInventoriesRouteRouteWithChildren
  AuthenticatedMinigamesRouteRoute: typeof AuthenticatedMinigamesRouteRouteWithChildren
  AuthenticatedPaymentTransactionsRouteRoute: typeof AuthenticatedPaymentTransactionsRouteRouteWithChildren
  AuthenticatedProductsRouteRoute: typeof AuthenticatedProductsRouteRouteWithChildren
  AuthenticatedRatingsRouteRoute: typeof AuthenticatedRatingsRouteRouteWithChildren
  AuthenticatedSurveysRouteRoute: typeof AuthenticatedSurveysRouteRouteWithChildren
  AuthenticatedVoucherTypesRouteRoute: typeof AuthenticatedVoucherTypesRouteRouteWithChildren
  AuthenticatedVouchersRouteRoute: typeof AuthenticatedVouchersRouteRouteWithChildren
  AuthenticatedSettingsRouteLazyRoute: typeof AuthenticatedSettingsRouteLazyRouteWithChildren
  AuthenticatedAffiliateAnalyticsLazyRoute: typeof AuthenticatedAffiliateAnalyticsLazyRoute
  AuthenticatedAffiliateConfigLazyRoute: typeof AuthenticatedAffiliateConfigLazyRoute
  AuthenticatedAffiliateRequestsLazyRoute: typeof AuthenticatedAffiliateRequestsLazyRoute
  AuthenticatedAffiliateTrackingLazyRoute: typeof AuthenticatedAffiliateTrackingLazyRoute
  AuthenticatedBookingsLazyRoute: typeof AuthenticatedBookingsLazyRoute
  AuthenticatedBranchesLazyRoute: typeof AuthenticatedBranchesLazyRoute
  AuthenticatedLoyaltyProgramsLazyRoute: typeof AuthenticatedLoyaltyProgramsLazyRoute
  AuthenticatedLoyaltyTiersLazyRoute: typeof AuthenticatedLoyaltyTiersLazyRoute
  AuthenticatedPointConfigLazyRoute: typeof AuthenticatedPointConfigLazyRoute
  AuthenticatedPointExpiryRulesLazyRoute: typeof AuthenticatedPointExpiryRulesLazyRoute
  AuthenticatedPointManagementLazyRoute: typeof AuthenticatedPointManagementLazyRoute
  AuthenticatedShareLinksLazyRoute: typeof AuthenticatedShareLinksLazyRoute
  AuthenticatedSlotsLazyRoute: typeof AuthenticatedSlotsLazyRoute
  AuthenticatedSyncProductLazyRoute: typeof AuthenticatedSyncProductLazyRoute
  AuthenticatedTenantsLazyRoute: typeof AuthenticatedTenantsLazyRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedApiHubCredentialsLazyRoute: typeof AuthenticatedApiHubCredentialsLazyRoute
  AuthenticatedMessageManagementOaLazyRoute: typeof AuthenticatedMessageManagementOaLazyRoute
  AuthenticatedMessageManagementSmsLazyRoute: typeof AuthenticatedMessageManagementSmsLazyRoute
  AuthenticatedMessageManagementViberLazyRoute: typeof AuthenticatedMessageManagementViberLazyRoute
  AuthenticatedMessageManagementZnsLazyRoute: typeof AuthenticatedMessageManagementZnsLazyRoute
  AuthenticatedMessagingSmsLazyRoute: typeof AuthenticatedMessagingSmsLazyRoute
  AuthenticatedMessagingViberLazyRoute: typeof AuthenticatedMessagingViberLazyRoute
  AuthenticatedOrdersOrderIdLazyRoute: typeof AuthenticatedOrdersOrderIdLazyRoute
  AuthenticatedReferralCodesLazyRoute: typeof AuthenticatedReferralCodesLazyRoute
  AuthenticatedReferralCommissionsLazyRoute: typeof AuthenticatedReferralCommissionsLazyRoute
  AuthenticatedReferralConfigLazyRoute: typeof AuthenticatedReferralConfigLazyRoute
  AuthenticatedReferralRelationshipsLazyRoute: typeof AuthenticatedReferralRelationshipsLazyRoute
  AuthenticatedZaloOaLazyRoute: typeof AuthenticatedZaloOaLazyRoute
  AuthenticatedZaloZnsLazyRoute: typeof AuthenticatedZaloZnsLazyRoute
  AuthenticatedGameRecordsIndexRoute: typeof AuthenticatedGameRecordsIndexRoute
  AuthenticatedAppsIndexLazyRoute: typeof AuthenticatedAppsIndexLazyRoute
  AuthenticatedArticlesIndexLazyRoute: typeof AuthenticatedArticlesIndexLazyRoute
  AuthenticatedCategoriesIndexLazyRoute: typeof AuthenticatedCategoriesIndexLazyRoute
  AuthenticatedChatsIndexLazyRoute: typeof AuthenticatedChatsIndexLazyRoute
  AuthenticatedColorsIndexLazyRoute: typeof AuthenticatedColorsIndexLazyRoute
  AuthenticatedContentCategoriesIndexLazyRoute: typeof AuthenticatedContentCategoriesIndexLazyRoute
  AuthenticatedEventCategoriesIndexLazyRoute: typeof AuthenticatedEventCategoriesIndexLazyRoute
  AuthenticatedEventsIndexLazyRoute: typeof AuthenticatedEventsIndexLazyRoute
  AuthenticatedHelpCenterIndexLazyRoute: typeof AuthenticatedHelpCenterIndexLazyRoute
  AuthenticatedOrderShippingIndexLazyRoute: typeof AuthenticatedOrderShippingIndexLazyRoute
  AuthenticatedOrdersIndexLazyRoute: typeof AuthenticatedOrdersIndexLazyRoute
  AuthenticatedReferralIndexLazyRoute: typeof AuthenticatedReferralIndexLazyRoute
  AuthenticatedTasksIndexLazyRoute: typeof AuthenticatedTasksIndexLazyRoute
  AuthenticatedUserManagementIndexLazyRoute: typeof AuthenticatedUserManagementIndexLazyRoute
  AuthenticatedMessagingOttCreateLazyRoute: typeof AuthenticatedMessagingOttCreateLazyRoute
  AuthenticatedArticlesArticleIdIndexLazyRoute: typeof AuthenticatedArticlesArticleIdIndexLazyRoute
  AuthenticatedArticlesCreateIndexLazyRoute: typeof AuthenticatedArticlesCreateIndexLazyRoute
  AuthenticatedEventsEventIdIndexLazyRoute: typeof AuthenticatedEventsEventIdIndexLazyRoute
  AuthenticatedEventsCreateIndexLazyRoute: typeof AuthenticatedEventsCreateIndexLazyRoute
  AuthenticatedMessageManagementOttCreateCreateLazyRoute: typeof AuthenticatedMessageManagementOttCreateCreateLazyRoute
  AuthenticatedArticlesArticleIdEditIndexLazyRoute: typeof AuthenticatedArticlesArticleIdEditIndexLazyRoute
  AuthenticatedEventsEventIdEditIndexLazyRoute: typeof AuthenticatedEventsEventIdEditIndexLazyRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedFlashSalesRouteRoute:
    AuthenticatedFlashSalesRouteRouteWithChildren,
  AuthenticatedFlashSalesInventoryRouteRoute:
    AuthenticatedFlashSalesInventoryRouteRouteWithChildren,
  AuthenticatedFnsResponsesRouteRoute:
    AuthenticatedFnsResponsesRouteRouteWithChildren,
  AuthenticatedFormsRouteRoute: AuthenticatedFormsRouteRouteWithChildren,
  AuthenticatedInventoriesRouteRoute:
    AuthenticatedInventoriesRouteRouteWithChildren,
  AuthenticatedMinigamesRouteRoute:
    AuthenticatedMinigamesRouteRouteWithChildren,
  AuthenticatedPaymentTransactionsRouteRoute:
    AuthenticatedPaymentTransactionsRouteRouteWithChildren,
  AuthenticatedProductsRouteRoute: AuthenticatedProductsRouteRouteWithChildren,
  AuthenticatedRatingsRouteRoute: AuthenticatedRatingsRouteRouteWithChildren,
  AuthenticatedSurveysRouteRoute: AuthenticatedSurveysRouteRouteWithChildren,
  AuthenticatedVoucherTypesRouteRoute:
    AuthenticatedVoucherTypesRouteRouteWithChildren,
  AuthenticatedVouchersRouteRoute: AuthenticatedVouchersRouteRouteWithChildren,
  AuthenticatedSettingsRouteLazyRoute:
    AuthenticatedSettingsRouteLazyRouteWithChildren,
  AuthenticatedAffiliateAnalyticsLazyRoute:
    AuthenticatedAffiliateAnalyticsLazyRoute,
  AuthenticatedAffiliateConfigLazyRoute: AuthenticatedAffiliateConfigLazyRoute,
  AuthenticatedAffiliateRequestsLazyRoute:
    AuthenticatedAffiliateRequestsLazyRoute,
  AuthenticatedAffiliateTrackingLazyRoute:
    AuthenticatedAffiliateTrackingLazyRoute,
  AuthenticatedBookingsLazyRoute: AuthenticatedBookingsLazyRoute,
  AuthenticatedBranchesLazyRoute: AuthenticatedBranchesLazyRoute,
  AuthenticatedLoyaltyProgramsLazyRoute: AuthenticatedLoyaltyProgramsLazyRoute,
  AuthenticatedLoyaltyTiersLazyRoute: AuthenticatedLoyaltyTiersLazyRoute,
  AuthenticatedPointConfigLazyRoute: AuthenticatedPointConfigLazyRoute,
  AuthenticatedPointExpiryRulesLazyRoute:
    AuthenticatedPointExpiryRulesLazyRoute,
  AuthenticatedPointManagementLazyRoute: AuthenticatedPointManagementLazyRoute,
  AuthenticatedShareLinksLazyRoute: AuthenticatedShareLinksLazyRoute,
  AuthenticatedSlotsLazyRoute: AuthenticatedSlotsLazyRoute,
  AuthenticatedSyncProductLazyRoute: AuthenticatedSyncProductLazyRoute,
  AuthenticatedTenantsLazyRoute: AuthenticatedTenantsLazyRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedApiHubCredentialsLazyRoute:
    AuthenticatedApiHubCredentialsLazyRoute,
  AuthenticatedMessageManagementOaLazyRoute:
    AuthenticatedMessageManagementOaLazyRoute,
  AuthenticatedMessageManagementSmsLazyRoute:
    AuthenticatedMessageManagementSmsLazyRoute,
  AuthenticatedMessageManagementViberLazyRoute:
    AuthenticatedMessageManagementViberLazyRoute,
  AuthenticatedMessageManagementZnsLazyRoute:
    AuthenticatedMessageManagementZnsLazyRoute,
  AuthenticatedMessagingSmsLazyRoute: AuthenticatedMessagingSmsLazyRoute,
  AuthenticatedMessagingViberLazyRoute: AuthenticatedMessagingViberLazyRoute,
  AuthenticatedOrdersOrderIdLazyRoute: AuthenticatedOrdersOrderIdLazyRoute,
  AuthenticatedReferralCodesLazyRoute: AuthenticatedReferralCodesLazyRoute,
  AuthenticatedReferralCommissionsLazyRoute:
    AuthenticatedReferralCommissionsLazyRoute,
  AuthenticatedReferralConfigLazyRoute: AuthenticatedReferralConfigLazyRoute,
  AuthenticatedReferralRelationshipsLazyRoute:
    AuthenticatedReferralRelationshipsLazyRoute,
  AuthenticatedZaloOaLazyRoute: AuthenticatedZaloOaLazyRoute,
  AuthenticatedZaloZnsLazyRoute: AuthenticatedZaloZnsLazyRoute,
  AuthenticatedGameRecordsIndexRoute: AuthenticatedGameRecordsIndexRoute,
  AuthenticatedAppsIndexLazyRoute: AuthenticatedAppsIndexLazyRoute,
  AuthenticatedArticlesIndexLazyRoute: AuthenticatedArticlesIndexLazyRoute,
  AuthenticatedCategoriesIndexLazyRoute: AuthenticatedCategoriesIndexLazyRoute,
  AuthenticatedChatsIndexLazyRoute: AuthenticatedChatsIndexLazyRoute,
  AuthenticatedColorsIndexLazyRoute: AuthenticatedColorsIndexLazyRoute,
  AuthenticatedContentCategoriesIndexLazyRoute:
    AuthenticatedContentCategoriesIndexLazyRoute,
  AuthenticatedEventCategoriesIndexLazyRoute:
    AuthenticatedEventCategoriesIndexLazyRoute,
  AuthenticatedEventsIndexLazyRoute: AuthenticatedEventsIndexLazyRoute,
  AuthenticatedHelpCenterIndexLazyRoute: AuthenticatedHelpCenterIndexLazyRoute,
  AuthenticatedOrderShippingIndexLazyRoute:
    AuthenticatedOrderShippingIndexLazyRoute,
  AuthenticatedOrdersIndexLazyRoute: AuthenticatedOrdersIndexLazyRoute,
  AuthenticatedReferralIndexLazyRoute: AuthenticatedReferralIndexLazyRoute,
  AuthenticatedTasksIndexLazyRoute: AuthenticatedTasksIndexLazyRoute,
  AuthenticatedUserManagementIndexLazyRoute:
    AuthenticatedUserManagementIndexLazyRoute,
  AuthenticatedMessagingOttCreateLazyRoute:
    AuthenticatedMessagingOttCreateLazyRoute,
  AuthenticatedArticlesArticleIdIndexLazyRoute:
    AuthenticatedArticlesArticleIdIndexLazyRoute,
  AuthenticatedArticlesCreateIndexLazyRoute:
    AuthenticatedArticlesCreateIndexLazyRoute,
  AuthenticatedEventsEventIdIndexLazyRoute:
    AuthenticatedEventsEventIdIndexLazyRoute,
  AuthenticatedEventsCreateIndexLazyRoute:
    AuthenticatedEventsCreateIndexLazyRoute,
  AuthenticatedMessageManagementOttCreateCreateLazyRoute:
    AuthenticatedMessageManagementOttCreateCreateLazyRoute,
  AuthenticatedArticlesArticleIdEditIndexLazyRoute:
    AuthenticatedArticlesArticleIdEditIndexLazyRoute,
  AuthenticatedEventsEventIdEditIndexLazyRoute:
    AuthenticatedEventsEventIdEditIndexLazyRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof AuthenticatedRouteRouteWithChildren
  '/flash-sales': typeof AuthenticatedFlashSalesRouteRouteWithChildren
  '/flash-sales-inventory': typeof AuthenticatedFlashSalesInventoryRouteRouteWithChildren
  '/fns-responses': typeof AuthenticatedFnsResponsesRouteRouteWithChildren
  '/forms': typeof AuthenticatedFormsRouteRouteWithChildren
  '/inventories': typeof AuthenticatedInventoriesRouteRouteWithChildren
  '/minigames': typeof AuthenticatedMinigamesRouteRouteWithChildren
  '/payment-transactions': typeof AuthenticatedPaymentTransactionsRouteRouteWithChildren
  '/products': typeof AuthenticatedProductsRouteRouteWithChildren
  '/ratings': typeof AuthenticatedRatingsRouteRouteWithChildren
  '/surveys': typeof AuthenticatedSurveysRouteRouteWithChildren
  '/voucher-types': typeof AuthenticatedVoucherTypesRouteRouteWithChildren
  '/vouchers': typeof AuthenticatedVouchersRouteRouteWithChildren
  '/otp': typeof authOtpRoute
  '/sign-in': typeof authSignInRoute
  '/settings': typeof AuthenticatedSettingsRouteLazyRouteWithChildren
  '/forgot-password': typeof authForgotPasswordLazyRoute
  '/sign-in-2': typeof authSignIn2LazyRoute
  '/sign-up': typeof authSignUpLazyRoute
  '/401': typeof errors401LazyRoute
  '/403': typeof errors403LazyRoute
  '/404': typeof errors404LazyRoute
  '/500': typeof errors500LazyRoute
  '/503': typeof errors503LazyRoute
  '/affiliate-analytics': typeof AuthenticatedAffiliateAnalyticsLazyRoute
  '/affiliate-config': typeof AuthenticatedAffiliateConfigLazyRoute
  '/affiliate-requests': typeof AuthenticatedAffiliateRequestsLazyRoute
  '/affiliate-tracking': typeof AuthenticatedAffiliateTrackingLazyRoute
  '/bookings': typeof AuthenticatedBookingsLazyRoute
  '/branches': typeof AuthenticatedBranchesLazyRoute
  '/loyalty-programs': typeof AuthenticatedLoyaltyProgramsLazyRoute
  '/loyalty-tiers': typeof AuthenticatedLoyaltyTiersLazyRoute
  '/point-config': typeof AuthenticatedPointConfigLazyRoute
  '/point-expiry-rules': typeof AuthenticatedPointExpiryRulesLazyRoute
  '/point-management': typeof AuthenticatedPointManagementLazyRoute
  '/share-links': typeof AuthenticatedShareLinksLazyRoute
  '/slots': typeof AuthenticatedSlotsLazyRoute
  '/sync-product': typeof AuthenticatedSyncProductLazyRoute
  '/tenants': typeof AuthenticatedTenantsLazyRoute
  '/': typeof AuthenticatedIndexRoute
  '/api-hub/credentials': typeof AuthenticatedApiHubCredentialsLazyRoute
  '/flash-sales-inventory/$campaignId': typeof AuthenticatedFlashSalesInventoryCampaignIdLazyRoute
  '/message-management/oa': typeof AuthenticatedMessageManagementOaLazyRoute
  '/message-management/sms': typeof AuthenticatedMessageManagementSmsLazyRoute
  '/message-management/viber': typeof AuthenticatedMessageManagementViberLazyRoute
  '/message-management/zns': typeof AuthenticatedMessageManagementZnsLazyRoute
  '/messaging/sms': typeof AuthenticatedMessagingSmsLazyRoute
  '/messaging/viber': typeof AuthenticatedMessagingViberLazyRoute
  '/minigames/create': typeof AuthenticatedMinigamesCreateLazyRoute
  '/minigames/templates': typeof AuthenticatedMinigamesTemplatesLazyRoute
  '/orders/$orderId': typeof AuthenticatedOrdersOrderIdLazyRoute
  '/referral/codes': typeof AuthenticatedReferralCodesLazyRoute
  '/referral/commissions': typeof AuthenticatedReferralCommissionsLazyRoute
  '/referral/config': typeof AuthenticatedReferralConfigLazyRoute
  '/referral/relationships': typeof AuthenticatedReferralRelationshipsLazyRoute
  '/settings/account': typeof AuthenticatedSettingsAccountLazyRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceLazyRoute
  '/settings/content': typeof AuthenticatedSettingsContentLazyRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayLazyRoute
  '/settings/general': typeof AuthenticatedSettingsGeneralLazyRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsLazyRoute
  '/settings/shipping': typeof AuthenticatedSettingsShippingLazyRoute
  '/zalo/oa': typeof AuthenticatedZaloOaLazyRoute
  '/zalo/zns': typeof AuthenticatedZaloZnsLazyRoute
  '/admin': typeof AdminAdminIndexRoute
  '/fns-responses/': typeof AuthenticatedFnsResponsesIndexRoute
  '/forms/': typeof AuthenticatedFormsIndexRoute
  '/game-records': typeof AuthenticatedGameRecordsIndexRoute
  '/surveys/': typeof AuthenticatedSurveysIndexRoute
  '/apps': typeof AuthenticatedAppsIndexLazyRoute
  '/articles': typeof AuthenticatedArticlesIndexLazyRoute
  '/categories': typeof AuthenticatedCategoriesIndexLazyRoute
  '/chats': typeof AuthenticatedChatsIndexLazyRoute
  '/colors': typeof AuthenticatedColorsIndexLazyRoute
  '/content-categories': typeof AuthenticatedContentCategoriesIndexLazyRoute
  '/event-categories': typeof AuthenticatedEventCategoriesIndexLazyRoute
  '/events': typeof AuthenticatedEventsIndexLazyRoute
  '/flash-sales-inventory/': typeof AuthenticatedFlashSalesInventoryIndexLazyRoute
  '/flash-sales/': typeof AuthenticatedFlashSalesIndexLazyRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexLazyRoute
  '/inventories/': typeof AuthenticatedInventoriesIndexLazyRoute
  '/minigames/': typeof AuthenticatedMinigamesIndexLazyRoute
  '/order-shipping': typeof AuthenticatedOrderShippingIndexLazyRoute
  '/orders': typeof AuthenticatedOrdersIndexLazyRoute
  '/payment-transactions/': typeof AuthenticatedPaymentTransactionsIndexLazyRoute
  '/products/': typeof AuthenticatedProductsIndexLazyRoute
  '/ratings/': typeof AuthenticatedRatingsIndexLazyRoute
  '/referral': typeof AuthenticatedReferralIndexLazyRoute
  '/settings/': typeof AuthenticatedSettingsIndexLazyRoute
  '/tasks': typeof AuthenticatedTasksIndexLazyRoute
  '/user-management': typeof AuthenticatedUserManagementIndexLazyRoute
  '/voucher-types/': typeof AuthenticatedVoucherTypesIndexLazyRoute
  '/vouchers/': typeof AuthenticatedVouchersIndexLazyRoute
  '/messaging/ott/create': typeof AuthenticatedMessagingOttCreateLazyRoute
  '/admin/agencies': typeof AdminAdminAgenciesIndexRoute
  '/admin/organizations': typeof AdminAdminOrganizationsIndexRoute
  '/forms/$formId': typeof AuthenticatedFormsFormIdIndexRoute
  '/forms/create': typeof AuthenticatedFormsCreateIndexRoute
  '/surveys/$surveyId': typeof AuthenticatedSurveysSurveyIdIndexRoute
  '/surveys/create': typeof AuthenticatedSurveysCreateIndexRoute
  '/admin/business-config': typeof AdminAdminBusinessConfigIndexLazyRoute
  '/admin/feature-flags': typeof AdminAdminFeatureFlagsIndexLazyRoute
  '/admin/feature-management': typeof AdminAdminFeatureManagementIndexLazyRoute
  '/admin/sdui': typeof AdminAdminSduiIndexLazyRoute
  '/admin/templates': typeof AdminAdminTemplatesIndexLazyRoute
  '/admin/tenants': typeof AdminAdminTenantsIndexLazyRoute
  '/admin/users': typeof AdminAdminUsersIndexLazyRoute
  '/articles/$articleId': typeof AuthenticatedArticlesArticleIdIndexLazyRoute
  '/articles/create': typeof AuthenticatedArticlesCreateIndexLazyRoute
  '/events/$eventId': typeof AuthenticatedEventsEventIdIndexLazyRoute
  '/events/create': typeof AuthenticatedEventsCreateIndexLazyRoute
  '/fns-responses/$responseId': typeof AuthenticatedFnsResponsesResponseIdIndexLazyRoute
  '/inventories/$inventoryId': typeof AuthenticatedInventoriesInventoryIdIndexLazyRoute
  '/minigames/$campaignId': typeof AuthenticatedMinigamesCampaignIdIndexLazyRoute
  '/payment-transactions/$transactionId': typeof AuthenticatedPaymentTransactionsTransactionIdIndexLazyRoute
  '/products/$productId': typeof AuthenticatedProductsProductIdIndexLazyRoute
  '/products/create': typeof AuthenticatedProductsCreateIndexLazyRoute
  '/voucher-types/$voucherTypeId': typeof AuthenticatedVoucherTypesVoucherTypeIdIndexLazyRoute
  '/voucher-types/create': typeof AuthenticatedVoucherTypesCreateIndexLazyRoute
  '/vouchers/$voucherId': typeof AuthenticatedVouchersVoucherIdIndexLazyRoute
  '/vouchers/create': typeof AuthenticatedVouchersCreateIndexLazyRoute
  '/message-management/ott/create/create': typeof AuthenticatedMessageManagementOttCreateCreateLazyRoute
  '/admin/templates/$templateId': typeof AdminAdminTemplatesTemplateIdIndexRoute
  '/admin/templates/create': typeof AdminAdminTemplatesCreateIndexRoute
  '/forms/$formId/edit': typeof AuthenticatedFormsFormIdEditIndexRoute
  '/surveys/$surveyId/edit': typeof AuthenticatedSurveysSurveyIdEditIndexRoute
  '/admin/api-hub/global-credentials': typeof AdminAdminApiHubGlobalCredentialsIndexLazyRoute
  '/admin/business-config/$configId': typeof AdminAdminBusinessConfigConfigIdIndexLazyRoute
  '/admin/business-config/create': typeof AdminAdminBusinessConfigCreateIndexLazyRoute
  '/admin/business-config/test': typeof AdminAdminBusinessConfigTestIndexLazyRoute
  '/admin/feature-flags/$featureFlagId': typeof AdminAdminFeatureFlagsFeatureFlagIdIndexLazyRoute
  '/admin/feature-flags/common': typeof AdminAdminFeatureFlagsCommonIndexLazyRoute
  '/admin/feature-flags/tenant-overrides': typeof AdminAdminFeatureFlagsTenantOverridesIndexLazyRoute
  '/admin/feature-flags/tenant': typeof AdminAdminFeatureFlagsTenantIndexLazyRoute
  '/admin/sdui/$sduiId': typeof AdminAdminSduiSduiIdIndexLazyRoute
  '/articles/$articleId/edit': typeof AuthenticatedArticlesArticleIdEditIndexLazyRoute
  '/events/$eventId/edit': typeof AuthenticatedEventsEventIdEditIndexLazyRoute
  '/minigames/$campaignId/edit': typeof AuthenticatedMinigamesCampaignIdEditIndexLazyRoute
  '/products/$productId/edit': typeof AuthenticatedProductsProductIdEditIndexLazyRoute
  '/voucher-types/$voucherTypeId/edit': typeof AuthenticatedVoucherTypesVoucherTypeIdEditIndexLazyRoute
  '/vouchers/$voucherId/edit': typeof AuthenticatedVouchersVoucherIdEditIndexLazyRoute
  '/admin/templates/$templateId/$versionId': typeof AdminAdminTemplatesTemplateIdVersionIdIndexRoute
  '/admin/business-config/$configId/edit': typeof AdminAdminBusinessConfigConfigIdEditIndexLazyRoute
  '/admin/templates/$templateId/version/$versionId': typeof AdminAdminTemplatesTemplateIdVersionVersionIdIndexRoute
}

export interface FileRoutesByTo {
  '': typeof AdminRouteRouteWithChildren
  '/otp': typeof authOtpRoute
  '/sign-in': typeof authSignInRoute
  '/forgot-password': typeof authForgotPasswordLazyRoute
  '/sign-in-2': typeof authSignIn2LazyRoute
  '/sign-up': typeof authSignUpLazyRoute
  '/401': typeof errors401LazyRoute
  '/403': typeof errors403LazyRoute
  '/404': typeof errors404LazyRoute
  '/500': typeof errors500LazyRoute
  '/503': typeof errors503LazyRoute
  '/affiliate-analytics': typeof AuthenticatedAffiliateAnalyticsLazyRoute
  '/affiliate-config': typeof AuthenticatedAffiliateConfigLazyRoute
  '/affiliate-requests': typeof AuthenticatedAffiliateRequestsLazyRoute
  '/affiliate-tracking': typeof AuthenticatedAffiliateTrackingLazyRoute
  '/bookings': typeof AuthenticatedBookingsLazyRoute
  '/branches': typeof AuthenticatedBranchesLazyRoute
  '/loyalty-programs': typeof AuthenticatedLoyaltyProgramsLazyRoute
  '/loyalty-tiers': typeof AuthenticatedLoyaltyTiersLazyRoute
  '/point-config': typeof AuthenticatedPointConfigLazyRoute
  '/point-expiry-rules': typeof AuthenticatedPointExpiryRulesLazyRoute
  '/point-management': typeof AuthenticatedPointManagementLazyRoute
  '/share-links': typeof AuthenticatedShareLinksLazyRoute
  '/slots': typeof AuthenticatedSlotsLazyRoute
  '/sync-product': typeof AuthenticatedSyncProductLazyRoute
  '/tenants': typeof AuthenticatedTenantsLazyRoute
  '/': typeof AuthenticatedIndexRoute
  '/api-hub/credentials': typeof AuthenticatedApiHubCredentialsLazyRoute
  '/flash-sales-inventory/$campaignId': typeof AuthenticatedFlashSalesInventoryCampaignIdLazyRoute
  '/message-management/oa': typeof AuthenticatedMessageManagementOaLazyRoute
  '/message-management/sms': typeof AuthenticatedMessageManagementSmsLazyRoute
  '/message-management/viber': typeof AuthenticatedMessageManagementViberLazyRoute
  '/message-management/zns': typeof AuthenticatedMessageManagementZnsLazyRoute
  '/messaging/sms': typeof AuthenticatedMessagingSmsLazyRoute
  '/messaging/viber': typeof AuthenticatedMessagingViberLazyRoute
  '/minigames/create': typeof AuthenticatedMinigamesCreateLazyRoute
  '/minigames/templates': typeof AuthenticatedMinigamesTemplatesLazyRoute
  '/orders/$orderId': typeof AuthenticatedOrdersOrderIdLazyRoute
  '/referral/codes': typeof AuthenticatedReferralCodesLazyRoute
  '/referral/commissions': typeof AuthenticatedReferralCommissionsLazyRoute
  '/referral/config': typeof AuthenticatedReferralConfigLazyRoute
  '/referral/relationships': typeof AuthenticatedReferralRelationshipsLazyRoute
  '/settings/account': typeof AuthenticatedSettingsAccountLazyRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceLazyRoute
  '/settings/content': typeof AuthenticatedSettingsContentLazyRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayLazyRoute
  '/settings/general': typeof AuthenticatedSettingsGeneralLazyRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsLazyRoute
  '/settings/shipping': typeof AuthenticatedSettingsShippingLazyRoute
  '/zalo/oa': typeof AuthenticatedZaloOaLazyRoute
  '/zalo/zns': typeof AuthenticatedZaloZnsLazyRoute
  '/admin': typeof AdminAdminIndexRoute
  '/fns-responses': typeof AuthenticatedFnsResponsesIndexRoute
  '/forms': typeof AuthenticatedFormsIndexRoute
  '/game-records': typeof AuthenticatedGameRecordsIndexRoute
  '/surveys': typeof AuthenticatedSurveysIndexRoute
  '/apps': typeof AuthenticatedAppsIndexLazyRoute
  '/articles': typeof AuthenticatedArticlesIndexLazyRoute
  '/categories': typeof AuthenticatedCategoriesIndexLazyRoute
  '/chats': typeof AuthenticatedChatsIndexLazyRoute
  '/colors': typeof AuthenticatedColorsIndexLazyRoute
  '/content-categories': typeof AuthenticatedContentCategoriesIndexLazyRoute
  '/event-categories': typeof AuthenticatedEventCategoriesIndexLazyRoute
  '/events': typeof AuthenticatedEventsIndexLazyRoute
  '/flash-sales-inventory': typeof AuthenticatedFlashSalesInventoryIndexLazyRoute
  '/flash-sales': typeof AuthenticatedFlashSalesIndexLazyRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexLazyRoute
  '/inventories': typeof AuthenticatedInventoriesIndexLazyRoute
  '/minigames': typeof AuthenticatedMinigamesIndexLazyRoute
  '/order-shipping': typeof AuthenticatedOrderShippingIndexLazyRoute
  '/orders': typeof AuthenticatedOrdersIndexLazyRoute
  '/payment-transactions': typeof AuthenticatedPaymentTransactionsIndexLazyRoute
  '/products': typeof AuthenticatedProductsIndexLazyRoute
  '/ratings': typeof AuthenticatedRatingsIndexLazyRoute
  '/referral': typeof AuthenticatedReferralIndexLazyRoute
  '/settings': typeof AuthenticatedSettingsIndexLazyRoute
  '/tasks': typeof AuthenticatedTasksIndexLazyRoute
  '/user-management': typeof AuthenticatedUserManagementIndexLazyRoute
  '/voucher-types': typeof AuthenticatedVoucherTypesIndexLazyRoute
  '/vouchers': typeof AuthenticatedVouchersIndexLazyRoute
  '/messaging/ott/create': typeof AuthenticatedMessagingOttCreateLazyRoute
  '/admin/agencies': typeof AdminAdminAgenciesIndexRoute
  '/admin/organizations': typeof AdminAdminOrganizationsIndexRoute
  '/forms/$formId': typeof AuthenticatedFormsFormIdIndexRoute
  '/forms/create': typeof AuthenticatedFormsCreateIndexRoute
  '/surveys/$surveyId': typeof AuthenticatedSurveysSurveyIdIndexRoute
  '/surveys/create': typeof AuthenticatedSurveysCreateIndexRoute
  '/admin/business-config': typeof AdminAdminBusinessConfigIndexLazyRoute
  '/admin/feature-flags': typeof AdminAdminFeatureFlagsIndexLazyRoute
  '/admin/feature-management': typeof AdminAdminFeatureManagementIndexLazyRoute
  '/admin/sdui': typeof AdminAdminSduiIndexLazyRoute
  '/admin/templates': typeof AdminAdminTemplatesIndexLazyRoute
  '/admin/tenants': typeof AdminAdminTenantsIndexLazyRoute
  '/admin/users': typeof AdminAdminUsersIndexLazyRoute
  '/articles/$articleId': typeof AuthenticatedArticlesArticleIdIndexLazyRoute
  '/articles/create': typeof AuthenticatedArticlesCreateIndexLazyRoute
  '/events/$eventId': typeof AuthenticatedEventsEventIdIndexLazyRoute
  '/events/create': typeof AuthenticatedEventsCreateIndexLazyRoute
  '/fns-responses/$responseId': typeof AuthenticatedFnsResponsesResponseIdIndexLazyRoute
  '/inventories/$inventoryId': typeof AuthenticatedInventoriesInventoryIdIndexLazyRoute
  '/minigames/$campaignId': typeof AuthenticatedMinigamesCampaignIdIndexLazyRoute
  '/payment-transactions/$transactionId': typeof AuthenticatedPaymentTransactionsTransactionIdIndexLazyRoute
  '/products/$productId': typeof AuthenticatedProductsProductIdIndexLazyRoute
  '/products/create': typeof AuthenticatedProductsCreateIndexLazyRoute
  '/voucher-types/$voucherTypeId': typeof AuthenticatedVoucherTypesVoucherTypeIdIndexLazyRoute
  '/voucher-types/create': typeof AuthenticatedVoucherTypesCreateIndexLazyRoute
  '/vouchers/$voucherId': typeof AuthenticatedVouchersVoucherIdIndexLazyRoute
  '/vouchers/create': typeof AuthenticatedVouchersCreateIndexLazyRoute
  '/message-management/ott/create/create': typeof AuthenticatedMessageManagementOttCreateCreateLazyRoute
  '/admin/templates/$templateId': typeof AdminAdminTemplatesTemplateIdIndexRoute
  '/admin/templates/create': typeof AdminAdminTemplatesCreateIndexRoute
  '/forms/$formId/edit': typeof AuthenticatedFormsFormIdEditIndexRoute
  '/surveys/$surveyId/edit': typeof AuthenticatedSurveysSurveyIdEditIndexRoute
  '/admin/api-hub/global-credentials': typeof AdminAdminApiHubGlobalCredentialsIndexLazyRoute
  '/admin/business-config/$configId': typeof AdminAdminBusinessConfigConfigIdIndexLazyRoute
  '/admin/business-config/create': typeof AdminAdminBusinessConfigCreateIndexLazyRoute
  '/admin/business-config/test': typeof AdminAdminBusinessConfigTestIndexLazyRoute
  '/admin/feature-flags/$featureFlagId': typeof AdminAdminFeatureFlagsFeatureFlagIdIndexLazyRoute
  '/admin/feature-flags/common': typeof AdminAdminFeatureFlagsCommonIndexLazyRoute
  '/admin/feature-flags/tenant-overrides': typeof AdminAdminFeatureFlagsTenantOverridesIndexLazyRoute
  '/admin/feature-flags/tenant': typeof AdminAdminFeatureFlagsTenantIndexLazyRoute
  '/admin/sdui/$sduiId': typeof AdminAdminSduiSduiIdIndexLazyRoute
  '/articles/$articleId/edit': typeof AuthenticatedArticlesArticleIdEditIndexLazyRoute
  '/events/$eventId/edit': typeof AuthenticatedEventsEventIdEditIndexLazyRoute
  '/minigames/$campaignId/edit': typeof AuthenticatedMinigamesCampaignIdEditIndexLazyRoute
  '/products/$productId/edit': typeof AuthenticatedProductsProductIdEditIndexLazyRoute
  '/voucher-types/$voucherTypeId/edit': typeof AuthenticatedVoucherTypesVoucherTypeIdEditIndexLazyRoute
  '/vouchers/$voucherId/edit': typeof AuthenticatedVouchersVoucherIdEditIndexLazyRoute
  '/admin/templates/$templateId/$versionId': typeof AdminAdminTemplatesTemplateIdVersionIdIndexRoute
  '/admin/business-config/$configId/edit': typeof AdminAdminBusinessConfigConfigIdEditIndexLazyRoute
  '/admin/templates/$templateId/version/$versionId': typeof AdminAdminTemplatesTemplateIdVersionVersionIdIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_admin': typeof AdminRouteRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_authenticated/flash-sales': typeof AuthenticatedFlashSalesRouteRouteWithChildren
  '/_authenticated/flash-sales-inventory': typeof AuthenticatedFlashSalesInventoryRouteRouteWithChildren
  '/_authenticated/fns-responses': typeof AuthenticatedFnsResponsesRouteRouteWithChildren
  '/_authenticated/forms': typeof AuthenticatedFormsRouteRouteWithChildren
  '/_authenticated/inventories': typeof AuthenticatedInventoriesRouteRouteWithChildren
  '/_authenticated/minigames': typeof AuthenticatedMinigamesRouteRouteWithChildren
  '/_authenticated/payment-transactions': typeof AuthenticatedPaymentTransactionsRouteRouteWithChildren
  '/_authenticated/products': typeof AuthenticatedProductsRouteRouteWithChildren
  '/_authenticated/ratings': typeof AuthenticatedRatingsRouteRouteWithChildren
  '/_authenticated/surveys': typeof AuthenticatedSurveysRouteRouteWithChildren
  '/_authenticated/voucher-types': typeof AuthenticatedVoucherTypesRouteRouteWithChildren
  '/_authenticated/vouchers': typeof AuthenticatedVouchersRouteRouteWithChildren
  '/(auth)/otp': typeof authOtpRoute
  '/(auth)/sign-in': typeof authSignInRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteLazyRouteWithChildren
  '/(auth)/forgot-password': typeof authForgotPasswordLazyRoute
  '/(auth)/sign-in-2': typeof authSignIn2LazyRoute
  '/(auth)/sign-up': typeof authSignUpLazyRoute
  '/(errors)/401': typeof errors401LazyRoute
  '/(errors)/403': typeof errors403LazyRoute
  '/(errors)/404': typeof errors404LazyRoute
  '/(errors)/500': typeof errors500LazyRoute
  '/(errors)/503': typeof errors503LazyRoute
  '/_authenticated/affiliate-analytics': typeof AuthenticatedAffiliateAnalyticsLazyRoute
  '/_authenticated/affiliate-config': typeof AuthenticatedAffiliateConfigLazyRoute
  '/_authenticated/affiliate-requests': typeof AuthenticatedAffiliateRequestsLazyRoute
  '/_authenticated/affiliate-tracking': typeof AuthenticatedAffiliateTrackingLazyRoute
  '/_authenticated/bookings': typeof AuthenticatedBookingsLazyRoute
  '/_authenticated/branches': typeof AuthenticatedBranchesLazyRoute
  '/_authenticated/loyalty-programs': typeof AuthenticatedLoyaltyProgramsLazyRoute
  '/_authenticated/loyalty-tiers': typeof AuthenticatedLoyaltyTiersLazyRoute
  '/_authenticated/point-config': typeof AuthenticatedPointConfigLazyRoute
  '/_authenticated/point-expiry-rules': typeof AuthenticatedPointExpiryRulesLazyRoute
  '/_authenticated/point-management': typeof AuthenticatedPointManagementLazyRoute
  '/_authenticated/share-links': typeof AuthenticatedShareLinksLazyRoute
  '/_authenticated/slots': typeof AuthenticatedSlotsLazyRoute
  '/_authenticated/sync-product': typeof AuthenticatedSyncProductLazyRoute
  '/_authenticated/tenants': typeof AuthenticatedTenantsLazyRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/api-hub/credentials': typeof AuthenticatedApiHubCredentialsLazyRoute
  '/_authenticated/flash-sales-inventory/$campaignId': typeof AuthenticatedFlashSalesInventoryCampaignIdLazyRoute
  '/_authenticated/message-management/oa': typeof AuthenticatedMessageManagementOaLazyRoute
  '/_authenticated/message-management/sms': typeof AuthenticatedMessageManagementSmsLazyRoute
  '/_authenticated/message-management/viber': typeof AuthenticatedMessageManagementViberLazyRoute
  '/_authenticated/message-management/zns': typeof AuthenticatedMessageManagementZnsLazyRoute
  '/_authenticated/messaging/sms': typeof AuthenticatedMessagingSmsLazyRoute
  '/_authenticated/messaging/viber': typeof AuthenticatedMessagingViberLazyRoute
  '/_authenticated/minigames/create': typeof AuthenticatedMinigamesCreateLazyRoute
  '/_authenticated/minigames/templates': typeof AuthenticatedMinigamesTemplatesLazyRoute
  '/_authenticated/orders/$orderId': typeof AuthenticatedOrdersOrderIdLazyRoute
  '/_authenticated/referral/codes': typeof AuthenticatedReferralCodesLazyRoute
  '/_authenticated/referral/commissions': typeof AuthenticatedReferralCommissionsLazyRoute
  '/_authenticated/referral/config': typeof AuthenticatedReferralConfigLazyRoute
  '/_authenticated/referral/relationships': typeof AuthenticatedReferralRelationshipsLazyRoute
  '/_authenticated/settings/account': typeof AuthenticatedSettingsAccountLazyRoute
  '/_authenticated/settings/appearance': typeof AuthenticatedSettingsAppearanceLazyRoute
  '/_authenticated/settings/content': typeof AuthenticatedSettingsContentLazyRoute
  '/_authenticated/settings/display': typeof AuthenticatedSettingsDisplayLazyRoute
  '/_authenticated/settings/general': typeof AuthenticatedSettingsGeneralLazyRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsLazyRoute
  '/_authenticated/settings/shipping': typeof AuthenticatedSettingsShippingLazyRoute
  '/_authenticated/zalo/oa': typeof AuthenticatedZaloOaLazyRoute
  '/_authenticated/zalo/zns': typeof AuthenticatedZaloZnsLazyRoute
  '/_admin/admin/': typeof AdminAdminIndexRoute
  '/_authenticated/fns-responses/': typeof AuthenticatedFnsResponsesIndexRoute
  '/_authenticated/forms/': typeof AuthenticatedFormsIndexRoute
  '/_authenticated/game-records/': typeof AuthenticatedGameRecordsIndexRoute
  '/_authenticated/surveys/': typeof AuthenticatedSurveysIndexRoute
  '/_authenticated/apps/': typeof AuthenticatedAppsIndexLazyRoute
  '/_authenticated/articles/': typeof AuthenticatedArticlesIndexLazyRoute
  '/_authenticated/categories/': typeof AuthenticatedCategoriesIndexLazyRoute
  '/_authenticated/chats/': typeof AuthenticatedChatsIndexLazyRoute
  '/_authenticated/colors/': typeof AuthenticatedColorsIndexLazyRoute
  '/_authenticated/content-categories/': typeof AuthenticatedContentCategoriesIndexLazyRoute
  '/_authenticated/event-categories/': typeof AuthenticatedEventCategoriesIndexLazyRoute
  '/_authenticated/events/': typeof AuthenticatedEventsIndexLazyRoute
  '/_authenticated/flash-sales-inventory/': typeof AuthenticatedFlashSalesInventoryIndexLazyRoute
  '/_authenticated/flash-sales/': typeof AuthenticatedFlashSalesIndexLazyRoute
  '/_authenticated/help-center/': typeof AuthenticatedHelpCenterIndexLazyRoute
  '/_authenticated/inventories/': typeof AuthenticatedInventoriesIndexLazyRoute
  '/_authenticated/minigames/': typeof AuthenticatedMinigamesIndexLazyRoute
  '/_authenticated/order-shipping/': typeof AuthenticatedOrderShippingIndexLazyRoute
  '/_authenticated/orders/': typeof AuthenticatedOrdersIndexLazyRoute
  '/_authenticated/payment-transactions/': typeof AuthenticatedPaymentTransactionsIndexLazyRoute
  '/_authenticated/products/': typeof AuthenticatedProductsIndexLazyRoute
  '/_authenticated/ratings/': typeof AuthenticatedRatingsIndexLazyRoute
  '/_authenticated/referral/': typeof AuthenticatedReferralIndexLazyRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexLazyRoute
  '/_authenticated/tasks/': typeof AuthenticatedTasksIndexLazyRoute
  '/_authenticated/user-management/': typeof AuthenticatedUserManagementIndexLazyRoute
  '/_authenticated/voucher-types/': typeof AuthenticatedVoucherTypesIndexLazyRoute
  '/_authenticated/vouchers/': typeof AuthenticatedVouchersIndexLazyRoute
  '/_authenticated/messaging/ott/create': typeof AuthenticatedMessagingOttCreateLazyRoute
  '/_admin/admin/agencies/': typeof AdminAdminAgenciesIndexRoute
  '/_admin/admin/organizations/': typeof AdminAdminOrganizationsIndexRoute
  '/_authenticated/forms/$formId/': typeof AuthenticatedFormsFormIdIndexRoute
  '/_authenticated/forms/create/': typeof AuthenticatedFormsCreateIndexRoute
  '/_authenticated/surveys/$surveyId/': typeof AuthenticatedSurveysSurveyIdIndexRoute
  '/_authenticated/surveys/create/': typeof AuthenticatedSurveysCreateIndexRoute
  '/_admin/admin/business-config/': typeof AdminAdminBusinessConfigIndexLazyRoute
  '/_admin/admin/feature-flags/': typeof AdminAdminFeatureFlagsIndexLazyRoute
  '/_admin/admin/feature-management/': typeof AdminAdminFeatureManagementIndexLazyRoute
  '/_admin/admin/sdui/': typeof AdminAdminSduiIndexLazyRoute
  '/_admin/admin/templates/': typeof AdminAdminTemplatesIndexLazyRoute
  '/_admin/admin/tenants/': typeof AdminAdminTenantsIndexLazyRoute
  '/_admin/admin/users/': typeof AdminAdminUsersIndexLazyRoute
  '/_authenticated/articles/$articleId/': typeof AuthenticatedArticlesArticleIdIndexLazyRoute
  '/_authenticated/articles/create/': typeof AuthenticatedArticlesCreateIndexLazyRoute
  '/_authenticated/events/$eventId/': typeof AuthenticatedEventsEventIdIndexLazyRoute
  '/_authenticated/events/create/': typeof AuthenticatedEventsCreateIndexLazyRoute
  '/_authenticated/fns-responses/$responseId/': typeof AuthenticatedFnsResponsesResponseIdIndexLazyRoute
  '/_authenticated/inventories/$inventoryId/': typeof AuthenticatedInventoriesInventoryIdIndexLazyRoute
  '/_authenticated/minigames/$campaignId/': typeof AuthenticatedMinigamesCampaignIdIndexLazyRoute
  '/_authenticated/payment-transactions/$transactionId/': typeof AuthenticatedPaymentTransactionsTransactionIdIndexLazyRoute
  '/_authenticated/products/$productId/': typeof AuthenticatedProductsProductIdIndexLazyRoute
  '/_authenticated/products/create/': typeof AuthenticatedProductsCreateIndexLazyRoute
  '/_authenticated/voucher-types/$voucherTypeId/': typeof AuthenticatedVoucherTypesVoucherTypeIdIndexLazyRoute
  '/_authenticated/voucher-types/create/': typeof AuthenticatedVoucherTypesCreateIndexLazyRoute
  '/_authenticated/vouchers/$voucherId/': typeof AuthenticatedVouchersVoucherIdIndexLazyRoute
  '/_authenticated/vouchers/create/': typeof AuthenticatedVouchersCreateIndexLazyRoute
  '/_authenticated/message-management/ott/create/create': typeof AuthenticatedMessageManagementOttCreateCreateLazyRoute
  '/_admin/admin/templates/$templateId/': typeof AdminAdminTemplatesTemplateIdIndexRoute
  '/_admin/admin/templates/create/': typeof AdminAdminTemplatesCreateIndexRoute
  '/_authenticated/forms/$formId/edit/': typeof AuthenticatedFormsFormIdEditIndexRoute
  '/_authenticated/surveys/$surveyId/edit/': typeof AuthenticatedSurveysSurveyIdEditIndexRoute
  '/_admin/admin/api-hub/global-credentials/': typeof AdminAdminApiHubGlobalCredentialsIndexLazyRoute
  '/_admin/admin/business-config/$configId/': typeof AdminAdminBusinessConfigConfigIdIndexLazyRoute
  '/_admin/admin/business-config/create/': typeof AdminAdminBusinessConfigCreateIndexLazyRoute
  '/_admin/admin/business-config/test/': typeof AdminAdminBusinessConfigTestIndexLazyRoute
  '/_admin/admin/feature-flags/$featureFlagId/': typeof AdminAdminFeatureFlagsFeatureFlagIdIndexLazyRoute
  '/_admin/admin/feature-flags/common/': typeof AdminAdminFeatureFlagsCommonIndexLazyRoute
  '/_admin/admin/feature-flags/tenant-overrides/': typeof AdminAdminFeatureFlagsTenantOverridesIndexLazyRoute
  '/_admin/admin/feature-flags/tenant/': typeof AdminAdminFeatureFlagsTenantIndexLazyRoute
  '/_admin/admin/sdui/$sduiId/': typeof AdminAdminSduiSduiIdIndexLazyRoute
  '/_authenticated/articles/$articleId/edit/': typeof AuthenticatedArticlesArticleIdEditIndexLazyRoute
  '/_authenticated/events/$eventId/edit/': typeof AuthenticatedEventsEventIdEditIndexLazyRoute
  '/_authenticated/minigames/$campaignId/edit/': typeof AuthenticatedMinigamesCampaignIdEditIndexLazyRoute
  '/_authenticated/products/$productId/edit/': typeof AuthenticatedProductsProductIdEditIndexLazyRoute
  '/_authenticated/voucher-types/$voucherTypeId/edit/': typeof AuthenticatedVoucherTypesVoucherTypeIdEditIndexLazyRoute
  '/_authenticated/vouchers/$voucherId/edit/': typeof AuthenticatedVouchersVoucherIdEditIndexLazyRoute
  '/_admin/admin/templates/$templateId/$versionId/': typeof AdminAdminTemplatesTemplateIdVersionIdIndexRoute
  '/_admin/admin/business-config/$configId/edit/': typeof AdminAdminBusinessConfigConfigIdEditIndexLazyRoute
  '/_admin/admin/templates/$templateId/version/$versionId/': typeof AdminAdminTemplatesTemplateIdVersionVersionIdIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/flash-sales'
    | '/flash-sales-inventory'
    | '/fns-responses'
    | '/forms'
    | '/inventories'
    | '/minigames'
    | '/payment-transactions'
    | '/products'
    | '/ratings'
    | '/surveys'
    | '/voucher-types'
    | '/vouchers'
    | '/otp'
    | '/sign-in'
    | '/settings'
    | '/forgot-password'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/affiliate-analytics'
    | '/affiliate-config'
    | '/affiliate-requests'
    | '/affiliate-tracking'
    | '/bookings'
    | '/branches'
    | '/loyalty-programs'
    | '/loyalty-tiers'
    | '/point-config'
    | '/point-expiry-rules'
    | '/point-management'
    | '/share-links'
    | '/slots'
    | '/sync-product'
    | '/tenants'
    | '/'
    | '/api-hub/credentials'
    | '/flash-sales-inventory/$campaignId'
    | '/message-management/oa'
    | '/message-management/sms'
    | '/message-management/viber'
    | '/message-management/zns'
    | '/messaging/sms'
    | '/messaging/viber'
    | '/minigames/create'
    | '/minigames/templates'
    | '/orders/$orderId'
    | '/referral/codes'
    | '/referral/commissions'
    | '/referral/config'
    | '/referral/relationships'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/content'
    | '/settings/display'
    | '/settings/general'
    | '/settings/notifications'
    | '/settings/shipping'
    | '/zalo/oa'
    | '/zalo/zns'
    | '/admin'
    | '/fns-responses/'
    | '/forms/'
    | '/game-records'
    | '/surveys/'
    | '/apps'
    | '/articles'
    | '/categories'
    | '/chats'
    | '/colors'
    | '/content-categories'
    | '/event-categories'
    | '/events'
    | '/flash-sales-inventory/'
    | '/flash-sales/'
    | '/help-center'
    | '/inventories/'
    | '/minigames/'
    | '/order-shipping'
    | '/orders'
    | '/payment-transactions/'
    | '/products/'
    | '/ratings/'
    | '/referral'
    | '/settings/'
    | '/tasks'
    | '/user-management'
    | '/voucher-types/'
    | '/vouchers/'
    | '/messaging/ott/create'
    | '/admin/agencies'
    | '/admin/organizations'
    | '/forms/$formId'
    | '/forms/create'
    | '/surveys/$surveyId'
    | '/surveys/create'
    | '/admin/business-config'
    | '/admin/feature-flags'
    | '/admin/feature-management'
    | '/admin/sdui'
    | '/admin/templates'
    | '/admin/tenants'
    | '/admin/users'
    | '/articles/$articleId'
    | '/articles/create'
    | '/events/$eventId'
    | '/events/create'
    | '/fns-responses/$responseId'
    | '/inventories/$inventoryId'
    | '/minigames/$campaignId'
    | '/payment-transactions/$transactionId'
    | '/products/$productId'
    | '/products/create'
    | '/voucher-types/$voucherTypeId'
    | '/voucher-types/create'
    | '/vouchers/$voucherId'
    | '/vouchers/create'
    | '/message-management/ott/create/create'
    | '/admin/templates/$templateId'
    | '/admin/templates/create'
    | '/forms/$formId/edit'
    | '/surveys/$surveyId/edit'
    | '/admin/api-hub/global-credentials'
    | '/admin/business-config/$configId'
    | '/admin/business-config/create'
    | '/admin/business-config/test'
    | '/admin/feature-flags/$featureFlagId'
    | '/admin/feature-flags/common'
    | '/admin/feature-flags/tenant-overrides'
    | '/admin/feature-flags/tenant'
    | '/admin/sdui/$sduiId'
    | '/articles/$articleId/edit'
    | '/events/$eventId/edit'
    | '/minigames/$campaignId/edit'
    | '/products/$productId/edit'
    | '/voucher-types/$voucherTypeId/edit'
    | '/vouchers/$voucherId/edit'
    | '/admin/templates/$templateId/$versionId'
    | '/admin/business-config/$configId/edit'
    | '/admin/templates/$templateId/version/$versionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/otp'
    | '/sign-in'
    | '/forgot-password'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/affiliate-analytics'
    | '/affiliate-config'
    | '/affiliate-requests'
    | '/affiliate-tracking'
    | '/bookings'
    | '/branches'
    | '/loyalty-programs'
    | '/loyalty-tiers'
    | '/point-config'
    | '/point-expiry-rules'
    | '/point-management'
    | '/share-links'
    | '/slots'
    | '/sync-product'
    | '/tenants'
    | '/'
    | '/api-hub/credentials'
    | '/flash-sales-inventory/$campaignId'
    | '/message-management/oa'
    | '/message-management/sms'
    | '/message-management/viber'
    | '/message-management/zns'
    | '/messaging/sms'
    | '/messaging/viber'
    | '/minigames/create'
    | '/minigames/templates'
    | '/orders/$orderId'
    | '/referral/codes'
    | '/referral/commissions'
    | '/referral/config'
    | '/referral/relationships'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/content'
    | '/settings/display'
    | '/settings/general'
    | '/settings/notifications'
    | '/settings/shipping'
    | '/zalo/oa'
    | '/zalo/zns'
    | '/admin'
    | '/fns-responses'
    | '/forms'
    | '/game-records'
    | '/surveys'
    | '/apps'
    | '/articles'
    | '/categories'
    | '/chats'
    | '/colors'
    | '/content-categories'
    | '/event-categories'
    | '/events'
    | '/flash-sales-inventory'
    | '/flash-sales'
    | '/help-center'
    | '/inventories'
    | '/minigames'
    | '/order-shipping'
    | '/orders'
    | '/payment-transactions'
    | '/products'
    | '/ratings'
    | '/referral'
    | '/settings'
    | '/tasks'
    | '/user-management'
    | '/voucher-types'
    | '/vouchers'
    | '/messaging/ott/create'
    | '/admin/agencies'
    | '/admin/organizations'
    | '/forms/$formId'
    | '/forms/create'
    | '/surveys/$surveyId'
    | '/surveys/create'
    | '/admin/business-config'
    | '/admin/feature-flags'
    | '/admin/feature-management'
    | '/admin/sdui'
    | '/admin/templates'
    | '/admin/tenants'
    | '/admin/users'
    | '/articles/$articleId'
    | '/articles/create'
    | '/events/$eventId'
    | '/events/create'
    | '/fns-responses/$responseId'
    | '/inventories/$inventoryId'
    | '/minigames/$campaignId'
    | '/payment-transactions/$transactionId'
    | '/products/$productId'
    | '/products/create'
    | '/voucher-types/$voucherTypeId'
    | '/voucher-types/create'
    | '/vouchers/$voucherId'
    | '/vouchers/create'
    | '/message-management/ott/create/create'
    | '/admin/templates/$templateId'
    | '/admin/templates/create'
    | '/forms/$formId/edit'
    | '/surveys/$surveyId/edit'
    | '/admin/api-hub/global-credentials'
    | '/admin/business-config/$configId'
    | '/admin/business-config/create'
    | '/admin/business-config/test'
    | '/admin/feature-flags/$featureFlagId'
    | '/admin/feature-flags/common'
    | '/admin/feature-flags/tenant-overrides'
    | '/admin/feature-flags/tenant'
    | '/admin/sdui/$sduiId'
    | '/articles/$articleId/edit'
    | '/events/$eventId/edit'
    | '/minigames/$campaignId/edit'
    | '/products/$productId/edit'
    | '/voucher-types/$voucherTypeId/edit'
    | '/vouchers/$voucherId/edit'
    | '/admin/templates/$templateId/$versionId'
    | '/admin/business-config/$configId/edit'
    | '/admin/templates/$templateId/version/$versionId'
  id:
    | '__root__'
    | '/_admin'
    | '/_authenticated'
    | '/_authenticated/flash-sales'
    | '/_authenticated/flash-sales-inventory'
    | '/_authenticated/fns-responses'
    | '/_authenticated/forms'
    | '/_authenticated/inventories'
    | '/_authenticated/minigames'
    | '/_authenticated/payment-transactions'
    | '/_authenticated/products'
    | '/_authenticated/ratings'
    | '/_authenticated/surveys'
    | '/_authenticated/voucher-types'
    | '/_authenticated/vouchers'
    | '/(auth)/otp'
    | '/(auth)/sign-in'
    | '/_authenticated/settings'
    | '/(auth)/forgot-password'
    | '/(auth)/sign-in-2'
    | '/(auth)/sign-up'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/affiliate-analytics'
    | '/_authenticated/affiliate-config'
    | '/_authenticated/affiliate-requests'
    | '/_authenticated/affiliate-tracking'
    | '/_authenticated/bookings'
    | '/_authenticated/branches'
    | '/_authenticated/loyalty-programs'
    | '/_authenticated/loyalty-tiers'
    | '/_authenticated/point-config'
    | '/_authenticated/point-expiry-rules'
    | '/_authenticated/point-management'
    | '/_authenticated/share-links'
    | '/_authenticated/slots'
    | '/_authenticated/sync-product'
    | '/_authenticated/tenants'
    | '/_authenticated/'
    | '/_authenticated/api-hub/credentials'
    | '/_authenticated/flash-sales-inventory/$campaignId'
    | '/_authenticated/message-management/oa'
    | '/_authenticated/message-management/sms'
    | '/_authenticated/message-management/viber'
    | '/_authenticated/message-management/zns'
    | '/_authenticated/messaging/sms'
    | '/_authenticated/messaging/viber'
    | '/_authenticated/minigames/create'
    | '/_authenticated/minigames/templates'
    | '/_authenticated/orders/$orderId'
    | '/_authenticated/referral/codes'
    | '/_authenticated/referral/commissions'
    | '/_authenticated/referral/config'
    | '/_authenticated/referral/relationships'
    | '/_authenticated/settings/account'
    | '/_authenticated/settings/appearance'
    | '/_authenticated/settings/content'
    | '/_authenticated/settings/display'
    | '/_authenticated/settings/general'
    | '/_authenticated/settings/notifications'
    | '/_authenticated/settings/shipping'
    | '/_authenticated/zalo/oa'
    | '/_authenticated/zalo/zns'
    | '/_admin/admin/'
    | '/_authenticated/fns-responses/'
    | '/_authenticated/forms/'
    | '/_authenticated/game-records/'
    | '/_authenticated/surveys/'
    | '/_authenticated/apps/'
    | '/_authenticated/articles/'
    | '/_authenticated/categories/'
    | '/_authenticated/chats/'
    | '/_authenticated/colors/'
    | '/_authenticated/content-categories/'
    | '/_authenticated/event-categories/'
    | '/_authenticated/events/'
    | '/_authenticated/flash-sales-inventory/'
    | '/_authenticated/flash-sales/'
    | '/_authenticated/help-center/'
    | '/_authenticated/inventories/'
    | '/_authenticated/minigames/'
    | '/_authenticated/order-shipping/'
    | '/_authenticated/orders/'
    | '/_authenticated/payment-transactions/'
    | '/_authenticated/products/'
    | '/_authenticated/ratings/'
    | '/_authenticated/referral/'
    | '/_authenticated/settings/'
    | '/_authenticated/tasks/'
    | '/_authenticated/user-management/'
    | '/_authenticated/voucher-types/'
    | '/_authenticated/vouchers/'
    | '/_authenticated/messaging/ott/create'
    | '/_admin/admin/agencies/'
    | '/_admin/admin/organizations/'
    | '/_authenticated/forms/$formId/'
    | '/_authenticated/forms/create/'
    | '/_authenticated/surveys/$surveyId/'
    | '/_authenticated/surveys/create/'
    | '/_admin/admin/business-config/'
    | '/_admin/admin/feature-flags/'
    | '/_admin/admin/feature-management/'
    | '/_admin/admin/sdui/'
    | '/_admin/admin/templates/'
    | '/_admin/admin/tenants/'
    | '/_admin/admin/users/'
    | '/_authenticated/articles/$articleId/'
    | '/_authenticated/articles/create/'
    | '/_authenticated/events/$eventId/'
    | '/_authenticated/events/create/'
    | '/_authenticated/fns-responses/$responseId/'
    | '/_authenticated/inventories/$inventoryId/'
    | '/_authenticated/minigames/$campaignId/'
    | '/_authenticated/payment-transactions/$transactionId/'
    | '/_authenticated/products/$productId/'
    | '/_authenticated/products/create/'
    | '/_authenticated/voucher-types/$voucherTypeId/'
    | '/_authenticated/voucher-types/create/'
    | '/_authenticated/vouchers/$voucherId/'
    | '/_authenticated/vouchers/create/'
    | '/_authenticated/message-management/ott/create/create'
    | '/_admin/admin/templates/$templateId/'
    | '/_admin/admin/templates/create/'
    | '/_authenticated/forms/$formId/edit/'
    | '/_authenticated/surveys/$surveyId/edit/'
    | '/_admin/admin/api-hub/global-credentials/'
    | '/_admin/admin/business-config/$configId/'
    | '/_admin/admin/business-config/create/'
    | '/_admin/admin/business-config/test/'
    | '/_admin/admin/feature-flags/$featureFlagId/'
    | '/_admin/admin/feature-flags/common/'
    | '/_admin/admin/feature-flags/tenant-overrides/'
    | '/_admin/admin/feature-flags/tenant/'
    | '/_admin/admin/sdui/$sduiId/'
    | '/_authenticated/articles/$articleId/edit/'
    | '/_authenticated/events/$eventId/edit/'
    | '/_authenticated/minigames/$campaignId/edit/'
    | '/_authenticated/products/$productId/edit/'
    | '/_authenticated/voucher-types/$voucherTypeId/edit/'
    | '/_authenticated/vouchers/$voucherId/edit/'
    | '/_admin/admin/templates/$templateId/$versionId/'
    | '/_admin/admin/business-config/$configId/edit/'
    | '/_admin/admin/templates/$templateId/version/$versionId/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  authOtpRoute: typeof authOtpRoute
  authSignInRoute: typeof authSignInRoute
  authForgotPasswordLazyRoute: typeof authForgotPasswordLazyRoute
  authSignIn2LazyRoute: typeof authSignIn2LazyRoute
  authSignUpLazyRoute: typeof authSignUpLazyRoute
  errors401LazyRoute: typeof errors401LazyRoute
  errors403LazyRoute: typeof errors403LazyRoute
  errors404LazyRoute: typeof errors404LazyRoute
  errors500LazyRoute: typeof errors500LazyRoute
  errors503LazyRoute: typeof errors503LazyRoute
}

const rootRouteChildren: RootRouteChildren = {
  AdminRouteRoute: AdminRouteRouteWithChildren,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  authOtpRoute: authOtpRoute,
  authSignInRoute: authSignInRoute,
  authForgotPasswordLazyRoute: authForgotPasswordLazyRoute,
  authSignIn2LazyRoute: authSignIn2LazyRoute,
  authSignUpLazyRoute: authSignUpLazyRoute,
  errors401LazyRoute: errors401LazyRoute,
  errors403LazyRoute: errors403LazyRoute,
  errors404LazyRoute: errors404LazyRoute,
  errors500LazyRoute: errors500LazyRoute,
  errors503LazyRoute: errors503LazyRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_admin",
        "/_authenticated",
        "/(auth)/otp",
        "/(auth)/sign-in",
        "/(auth)/forgot-password",
        "/(auth)/sign-in-2",
        "/(auth)/sign-up",
        "/(errors)/401",
        "/(errors)/403",
        "/(errors)/404",
        "/(errors)/500",
        "/(errors)/503"
      ]
    },
    "/_admin": {
      "filePath": "_admin/route.tsx",
      "children": [
        "/_admin/admin/",
        "/_admin/admin/agencies/",
        "/_admin/admin/organizations/",
        "/_admin/admin/business-config/",
        "/_admin/admin/feature-flags/",
        "/_admin/admin/feature-management/",
        "/_admin/admin/sdui/",
        "/_admin/admin/templates/",
        "/_admin/admin/tenants/",
        "/_admin/admin/users/",
        "/_admin/admin/templates/$templateId/",
        "/_admin/admin/templates/create/",
        "/_admin/admin/api-hub/global-credentials/",
        "/_admin/admin/business-config/$configId/",
        "/_admin/admin/business-config/create/",
        "/_admin/admin/business-config/test/",
        "/_admin/admin/feature-flags/$featureFlagId/",
        "/_admin/admin/feature-flags/common/",
        "/_admin/admin/feature-flags/tenant-overrides/",
        "/_admin/admin/feature-flags/tenant/",
        "/_admin/admin/sdui/$sduiId/",
        "/_admin/admin/templates/$templateId/$versionId/",
        "/_admin/admin/business-config/$configId/edit/",
        "/_admin/admin/templates/$templateId/version/$versionId/"
      ]
    },
    "/_authenticated": {
      "filePath": "_authenticated/route.tsx",
      "children": [
        "/_authenticated/flash-sales",
        "/_authenticated/flash-sales-inventory",
        "/_authenticated/fns-responses",
        "/_authenticated/forms",
        "/_authenticated/inventories",
        "/_authenticated/minigames",
        "/_authenticated/payment-transactions",
        "/_authenticated/products",
        "/_authenticated/ratings",
        "/_authenticated/surveys",
        "/_authenticated/voucher-types",
        "/_authenticated/vouchers",
        "/_authenticated/settings",
        "/_authenticated/affiliate-analytics",
        "/_authenticated/affiliate-config",
        "/_authenticated/affiliate-requests",
        "/_authenticated/affiliate-tracking",
        "/_authenticated/bookings",
        "/_authenticated/branches",
        "/_authenticated/loyalty-programs",
        "/_authenticated/loyalty-tiers",
        "/_authenticated/point-config",
        "/_authenticated/point-expiry-rules",
        "/_authenticated/point-management",
        "/_authenticated/share-links",
        "/_authenticated/slots",
        "/_authenticated/sync-product",
        "/_authenticated/tenants",
        "/_authenticated/",
        "/_authenticated/api-hub/credentials",
        "/_authenticated/message-management/oa",
        "/_authenticated/message-management/sms",
        "/_authenticated/message-management/viber",
        "/_authenticated/message-management/zns",
        "/_authenticated/messaging/sms",
        "/_authenticated/messaging/viber",
        "/_authenticated/orders/$orderId",
        "/_authenticated/referral/codes",
        "/_authenticated/referral/commissions",
        "/_authenticated/referral/config",
        "/_authenticated/referral/relationships",
        "/_authenticated/zalo/oa",
        "/_authenticated/zalo/zns",
        "/_authenticated/game-records/",
        "/_authenticated/apps/",
        "/_authenticated/articles/",
        "/_authenticated/categories/",
        "/_authenticated/chats/",
        "/_authenticated/colors/",
        "/_authenticated/content-categories/",
        "/_authenticated/event-categories/",
        "/_authenticated/events/",
        "/_authenticated/help-center/",
        "/_authenticated/order-shipping/",
        "/_authenticated/orders/",
        "/_authenticated/referral/",
        "/_authenticated/tasks/",
        "/_authenticated/user-management/",
        "/_authenticated/messaging/ott/create",
        "/_authenticated/articles/$articleId/",
        "/_authenticated/articles/create/",
        "/_authenticated/events/$eventId/",
        "/_authenticated/events/create/",
        "/_authenticated/message-management/ott/create/create",
        "/_authenticated/articles/$articleId/edit/",
        "/_authenticated/events/$eventId/edit/"
      ]
    },
    "/_authenticated/flash-sales": {
      "filePath": "_authenticated/flash-sales/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/flash-sales/"
      ]
    },
    "/_authenticated/flash-sales-inventory": {
      "filePath": "_authenticated/flash-sales-inventory/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/flash-sales-inventory/$campaignId",
        "/_authenticated/flash-sales-inventory/"
      ]
    },
    "/_authenticated/fns-responses": {
      "filePath": "_authenticated/fns-responses/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/fns-responses/",
        "/_authenticated/fns-responses/$responseId/"
      ]
    },
    "/_authenticated/forms": {
      "filePath": "_authenticated/forms/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/forms/",
        "/_authenticated/forms/$formId/",
        "/_authenticated/forms/create/",
        "/_authenticated/forms/$formId/edit/"
      ]
    },
    "/_authenticated/inventories": {
      "filePath": "_authenticated/inventories/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/inventories/",
        "/_authenticated/inventories/$inventoryId/"
      ]
    },
    "/_authenticated/minigames": {
      "filePath": "_authenticated/minigames/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/minigames/create",
        "/_authenticated/minigames/templates",
        "/_authenticated/minigames/",
        "/_authenticated/minigames/$campaignId/",
        "/_authenticated/minigames/$campaignId/edit/"
      ]
    },
    "/_authenticated/payment-transactions": {
      "filePath": "_authenticated/payment-transactions/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/payment-transactions/",
        "/_authenticated/payment-transactions/$transactionId/"
      ]
    },
    "/_authenticated/products": {
      "filePath": "_authenticated/products/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/products/",
        "/_authenticated/products/$productId/",
        "/_authenticated/products/create/",
        "/_authenticated/products/$productId/edit/"
      ]
    },
    "/_authenticated/ratings": {
      "filePath": "_authenticated/ratings/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/ratings/"
      ]
    },
    "/_authenticated/surveys": {
      "filePath": "_authenticated/surveys/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/surveys/",
        "/_authenticated/surveys/$surveyId/",
        "/_authenticated/surveys/create/",
        "/_authenticated/surveys/$surveyId/edit/"
      ]
    },
    "/_authenticated/voucher-types": {
      "filePath": "_authenticated/voucher-types/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/voucher-types/",
        "/_authenticated/voucher-types/$voucherTypeId/",
        "/_authenticated/voucher-types/create/",
        "/_authenticated/voucher-types/$voucherTypeId/edit/"
      ]
    },
    "/_authenticated/vouchers": {
      "filePath": "_authenticated/vouchers/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/vouchers/",
        "/_authenticated/vouchers/$voucherId/",
        "/_authenticated/vouchers/create/",
        "/_authenticated/vouchers/$voucherId/edit/"
      ]
    },
    "/(auth)/otp": {
      "filePath": "(auth)/otp.tsx"
    },
    "/(auth)/sign-in": {
      "filePath": "(auth)/sign-in.tsx"
    },
    "/_authenticated/settings": {
      "filePath": "_authenticated/settings/route.lazy.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/settings/account",
        "/_authenticated/settings/appearance",
        "/_authenticated/settings/content",
        "/_authenticated/settings/display",
        "/_authenticated/settings/general",
        "/_authenticated/settings/notifications",
        "/_authenticated/settings/shipping",
        "/_authenticated/settings/"
      ]
    },
    "/(auth)/forgot-password": {
      "filePath": "(auth)/forgot-password.lazy.tsx"
    },
    "/(auth)/sign-in-2": {
      "filePath": "(auth)/sign-in-2.lazy.tsx"
    },
    "/(auth)/sign-up": {
      "filePath": "(auth)/sign-up.lazy.tsx"
    },
    "/(errors)/401": {
      "filePath": "(errors)/401.lazy.tsx"
    },
    "/(errors)/403": {
      "filePath": "(errors)/403.lazy.tsx"
    },
    "/(errors)/404": {
      "filePath": "(errors)/404.lazy.tsx"
    },
    "/(errors)/500": {
      "filePath": "(errors)/500.lazy.tsx"
    },
    "/(errors)/503": {
      "filePath": "(errors)/503.lazy.tsx"
    },
    "/_authenticated/affiliate-analytics": {
      "filePath": "_authenticated/affiliate-analytics.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/affiliate-config": {
      "filePath": "_authenticated/affiliate-config.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/affiliate-requests": {
      "filePath": "_authenticated/affiliate-requests.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/affiliate-tracking": {
      "filePath": "_authenticated/affiliate-tracking.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/bookings": {
      "filePath": "_authenticated/bookings.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/branches": {
      "filePath": "_authenticated/branches.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/loyalty-programs": {
      "filePath": "_authenticated/loyalty-programs.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/loyalty-tiers": {
      "filePath": "_authenticated/loyalty-tiers.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/point-config": {
      "filePath": "_authenticated/point-config.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/point-expiry-rules": {
      "filePath": "_authenticated/point-expiry-rules.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/point-management": {
      "filePath": "_authenticated/point-management.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/share-links": {
      "filePath": "_authenticated/share-links.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/slots": {
      "filePath": "_authenticated/slots.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/sync-product": {
      "filePath": "_authenticated/sync-product.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/tenants": {
      "filePath": "_authenticated/tenants.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/": {
      "filePath": "_authenticated/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/api-hub/credentials": {
      "filePath": "_authenticated/api-hub/credentials.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/flash-sales-inventory/$campaignId": {
      "filePath": "_authenticated/flash-sales-inventory/$campaignId.lazy.tsx",
      "parent": "/_authenticated/flash-sales-inventory"
    },
    "/_authenticated/message-management/oa": {
      "filePath": "_authenticated/message-management/oa.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/message-management/sms": {
      "filePath": "_authenticated/message-management/sms.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/message-management/viber": {
      "filePath": "_authenticated/message-management/viber.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/message-management/zns": {
      "filePath": "_authenticated/message-management/zns.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/messaging/sms": {
      "filePath": "_authenticated/messaging/sms.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/messaging/viber": {
      "filePath": "_authenticated/messaging/viber.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/minigames/create": {
      "filePath": "_authenticated/minigames/create.lazy.tsx",
      "parent": "/_authenticated/minigames"
    },
    "/_authenticated/minigames/templates": {
      "filePath": "_authenticated/minigames/templates.lazy.tsx",
      "parent": "/_authenticated/minigames"
    },
    "/_authenticated/orders/$orderId": {
      "filePath": "_authenticated/orders/$orderId.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/referral/codes": {
      "filePath": "_authenticated/referral/codes.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/referral/commissions": {
      "filePath": "_authenticated/referral/commissions.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/referral/config": {
      "filePath": "_authenticated/referral/config.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/referral/relationships": {
      "filePath": "_authenticated/referral/relationships.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/settings/account": {
      "filePath": "_authenticated/settings/account.lazy.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/settings/appearance": {
      "filePath": "_authenticated/settings/appearance.lazy.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/settings/content": {
      "filePath": "_authenticated/settings/content.lazy.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/settings/display": {
      "filePath": "_authenticated/settings/display.lazy.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/settings/general": {
      "filePath": "_authenticated/settings/general.lazy.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/settings/notifications": {
      "filePath": "_authenticated/settings/notifications.lazy.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/settings/shipping": {
      "filePath": "_authenticated/settings/shipping.lazy.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/zalo/oa": {
      "filePath": "_authenticated/zalo/oa.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/zalo/zns": {
      "filePath": "_authenticated/zalo/zns.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_admin/admin/": {
      "filePath": "_admin/admin/index.tsx",
      "parent": "/_admin"
    },
    "/_authenticated/fns-responses/": {
      "filePath": "_authenticated/fns-responses/index.tsx",
      "parent": "/_authenticated/fns-responses"
    },
    "/_authenticated/forms/": {
      "filePath": "_authenticated/forms/index.tsx",
      "parent": "/_authenticated/forms"
    },
    "/_authenticated/game-records/": {
      "filePath": "_authenticated/game-records/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/surveys/": {
      "filePath": "_authenticated/surveys/index.tsx",
      "parent": "/_authenticated/surveys"
    },
    "/_authenticated/apps/": {
      "filePath": "_authenticated/apps/index.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/articles/": {
      "filePath": "_authenticated/articles/index.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/categories/": {
      "filePath": "_authenticated/categories/index.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/chats/": {
      "filePath": "_authenticated/chats/index.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/colors/": {
      "filePath": "_authenticated/colors/index.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/content-categories/": {
      "filePath": "_authenticated/content-categories/index.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/event-categories/": {
      "filePath": "_authenticated/event-categories/index.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/events/": {
      "filePath": "_authenticated/events/index.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/flash-sales-inventory/": {
      "filePath": "_authenticated/flash-sales-inventory/index.lazy.tsx",
      "parent": "/_authenticated/flash-sales-inventory"
    },
    "/_authenticated/flash-sales/": {
      "filePath": "_authenticated/flash-sales/index.lazy.tsx",
      "parent": "/_authenticated/flash-sales"
    },
    "/_authenticated/help-center/": {
      "filePath": "_authenticated/help-center/index.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/inventories/": {
      "filePath": "_authenticated/inventories/index.lazy.tsx",
      "parent": "/_authenticated/inventories"
    },
    "/_authenticated/minigames/": {
      "filePath": "_authenticated/minigames/index.lazy.tsx",
      "parent": "/_authenticated/minigames"
    },
    "/_authenticated/order-shipping/": {
      "filePath": "_authenticated/order-shipping/index.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/orders/": {
      "filePath": "_authenticated/orders/index.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/payment-transactions/": {
      "filePath": "_authenticated/payment-transactions/index.lazy.tsx",
      "parent": "/_authenticated/payment-transactions"
    },
    "/_authenticated/products/": {
      "filePath": "_authenticated/products/index.lazy.tsx",
      "parent": "/_authenticated/products"
    },
    "/_authenticated/ratings/": {
      "filePath": "_authenticated/ratings/index.lazy.tsx",
      "parent": "/_authenticated/ratings"
    },
    "/_authenticated/referral/": {
      "filePath": "_authenticated/referral/index.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/settings/": {
      "filePath": "_authenticated/settings/index.lazy.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/tasks/": {
      "filePath": "_authenticated/tasks/index.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/user-management/": {
      "filePath": "_authenticated/user-management/index.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/voucher-types/": {
      "filePath": "_authenticated/voucher-types/index.lazy.tsx",
      "parent": "/_authenticated/voucher-types"
    },
    "/_authenticated/vouchers/": {
      "filePath": "_authenticated/vouchers/index.lazy.tsx",
      "parent": "/_authenticated/vouchers"
    },
    "/_authenticated/messaging/ott/create": {
      "filePath": "_authenticated/messaging/ott/create.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_admin/admin/agencies/": {
      "filePath": "_admin/admin/agencies/index.tsx",
      "parent": "/_admin"
    },
    "/_admin/admin/organizations/": {
      "filePath": "_admin/admin/organizations/index.tsx",
      "parent": "/_admin"
    },
    "/_authenticated/forms/$formId/": {
      "filePath": "_authenticated/forms/$formId/index.tsx",
      "parent": "/_authenticated/forms"
    },
    "/_authenticated/forms/create/": {
      "filePath": "_authenticated/forms/create/index.tsx",
      "parent": "/_authenticated/forms"
    },
    "/_authenticated/surveys/$surveyId/": {
      "filePath": "_authenticated/surveys/$surveyId/index.tsx",
      "parent": "/_authenticated/surveys"
    },
    "/_authenticated/surveys/create/": {
      "filePath": "_authenticated/surveys/create/index.tsx",
      "parent": "/_authenticated/surveys"
    },
    "/_admin/admin/business-config/": {
      "filePath": "_admin/admin/business-config/index.lazy.tsx",
      "parent": "/_admin"
    },
    "/_admin/admin/feature-flags/": {
      "filePath": "_admin/admin/feature-flags/index.lazy.tsx",
      "parent": "/_admin"
    },
    "/_admin/admin/feature-management/": {
      "filePath": "_admin/admin/feature-management/index.lazy.tsx",
      "parent": "/_admin"
    },
    "/_admin/admin/sdui/": {
      "filePath": "_admin/admin/sdui/index.lazy.tsx",
      "parent": "/_admin"
    },
    "/_admin/admin/templates/": {
      "filePath": "_admin/admin/templates/index.lazy.tsx",
      "parent": "/_admin"
    },
    "/_admin/admin/tenants/": {
      "filePath": "_admin/admin/tenants/index.lazy.tsx",
      "parent": "/_admin"
    },
    "/_admin/admin/users/": {
      "filePath": "_admin/admin/users/index.lazy.tsx",
      "parent": "/_admin"
    },
    "/_authenticated/articles/$articleId/": {
      "filePath": "_authenticated/articles/$articleId/index.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/articles/create/": {
      "filePath": "_authenticated/articles/create/index.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/events/$eventId/": {
      "filePath": "_authenticated/events/$eventId/index.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/events/create/": {
      "filePath": "_authenticated/events/create/index.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/fns-responses/$responseId/": {
      "filePath": "_authenticated/fns-responses/$responseId/index.lazy.tsx",
      "parent": "/_authenticated/fns-responses"
    },
    "/_authenticated/inventories/$inventoryId/": {
      "filePath": "_authenticated/inventories/$inventoryId/index.lazy.tsx",
      "parent": "/_authenticated/inventories"
    },
    "/_authenticated/minigames/$campaignId/": {
      "filePath": "_authenticated/minigames/$campaignId/index.lazy.tsx",
      "parent": "/_authenticated/minigames"
    },
    "/_authenticated/payment-transactions/$transactionId/": {
      "filePath": "_authenticated/payment-transactions/$transactionId/index.lazy.tsx",
      "parent": "/_authenticated/payment-transactions"
    },
    "/_authenticated/products/$productId/": {
      "filePath": "_authenticated/products/$productId/index.lazy.tsx",
      "parent": "/_authenticated/products"
    },
    "/_authenticated/products/create/": {
      "filePath": "_authenticated/products/create/index.lazy.tsx",
      "parent": "/_authenticated/products"
    },
    "/_authenticated/voucher-types/$voucherTypeId/": {
      "filePath": "_authenticated/voucher-types/$voucherTypeId/index.lazy.tsx",
      "parent": "/_authenticated/voucher-types"
    },
    "/_authenticated/voucher-types/create/": {
      "filePath": "_authenticated/voucher-types/create/index.lazy.tsx",
      "parent": "/_authenticated/voucher-types"
    },
    "/_authenticated/vouchers/$voucherId/": {
      "filePath": "_authenticated/vouchers/$voucherId/index.lazy.tsx",
      "parent": "/_authenticated/vouchers"
    },
    "/_authenticated/vouchers/create/": {
      "filePath": "_authenticated/vouchers/create/index.lazy.tsx",
      "parent": "/_authenticated/vouchers"
    },
    "/_authenticated/message-management/ott/create/create": {
      "filePath": "_authenticated/message-management/ott/create/create.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_admin/admin/templates/$templateId/": {
      "filePath": "_admin/admin/templates/$templateId/index.tsx",
      "parent": "/_admin"
    },
    "/_admin/admin/templates/create/": {
      "filePath": "_admin/admin/templates/create/index.tsx",
      "parent": "/_admin"
    },
    "/_authenticated/forms/$formId/edit/": {
      "filePath": "_authenticated/forms/$formId/edit/index.tsx",
      "parent": "/_authenticated/forms"
    },
    "/_authenticated/surveys/$surveyId/edit/": {
      "filePath": "_authenticated/surveys/$surveyId/edit/index.tsx",
      "parent": "/_authenticated/surveys"
    },
    "/_admin/admin/api-hub/global-credentials/": {
      "filePath": "_admin/admin/api-hub/global-credentials/index.lazy.tsx",
      "parent": "/_admin"
    },
    "/_admin/admin/business-config/$configId/": {
      "filePath": "_admin/admin/business-config/$configId/index.lazy.tsx",
      "parent": "/_admin"
    },
    "/_admin/admin/business-config/create/": {
      "filePath": "_admin/admin/business-config/create/index.lazy.tsx",
      "parent": "/_admin"
    },
    "/_admin/admin/business-config/test/": {
      "filePath": "_admin/admin/business-config/test/index.lazy.tsx",
      "parent": "/_admin"
    },
    "/_admin/admin/feature-flags/$featureFlagId/": {
      "filePath": "_admin/admin/feature-flags/$featureFlagId/index.lazy.tsx",
      "parent": "/_admin"
    },
    "/_admin/admin/feature-flags/common/": {
      "filePath": "_admin/admin/feature-flags/common/index.lazy.tsx",
      "parent": "/_admin"
    },
    "/_admin/admin/feature-flags/tenant-overrides/": {
      "filePath": "_admin/admin/feature-flags/tenant-overrides/index.lazy.tsx",
      "parent": "/_admin"
    },
    "/_admin/admin/feature-flags/tenant/": {
      "filePath": "_admin/admin/feature-flags/tenant/index.lazy.tsx",
      "parent": "/_admin"
    },
    "/_admin/admin/sdui/$sduiId/": {
      "filePath": "_admin/admin/sdui/$sduiId/index.lazy.tsx",
      "parent": "/_admin"
    },
    "/_authenticated/articles/$articleId/edit/": {
      "filePath": "_authenticated/articles/$articleId/edit/index.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/events/$eventId/edit/": {
      "filePath": "_authenticated/events/$eventId/edit/index.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/minigames/$campaignId/edit/": {
      "filePath": "_authenticated/minigames/$campaignId/edit/index.lazy.tsx",
      "parent": "/_authenticated/minigames"
    },
    "/_authenticated/products/$productId/edit/": {
      "filePath": "_authenticated/products/$productId/edit/index.lazy.tsx",
      "parent": "/_authenticated/products"
    },
    "/_authenticated/voucher-types/$voucherTypeId/edit/": {
      "filePath": "_authenticated/voucher-types/$voucherTypeId/edit/index.lazy.tsx",
      "parent": "/_authenticated/voucher-types"
    },
    "/_authenticated/vouchers/$voucherId/edit/": {
      "filePath": "_authenticated/vouchers/$voucherId/edit/index.lazy.tsx",
      "parent": "/_authenticated/vouchers"
    },
    "/_admin/admin/templates/$templateId/$versionId/": {
      "filePath": "_admin/admin/templates/$templateId/$versionId/index.tsx",
      "parent": "/_admin"
    },
    "/_admin/admin/business-config/$configId/edit/": {
      "filePath": "_admin/admin/business-config/$configId/edit/index.lazy.tsx",
      "parent": "/_admin"
    },
    "/_admin/admin/templates/$templateId/version/$versionId/": {
      "filePath": "_admin/admin/templates/$templateId/version/$versionId/index.tsx",
      "parent": "/_admin"
    }
  }
}
ROUTE_MANIFEST_END */
